// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/img/new-course-icon2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/img/approve-course-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/img/assign-course-icon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
    outline: none !important;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

html {
    position: relative;
    font-size: 1rem;
    height: 100%;
    text-rendering: optimizeLegibility;

}

:root {
    --fontBarlow: "Barlow", sans-serif;
    --fontOpenSans: "Open Sans", sans-serif;
    --Awesome: "FontAwesome", sans-serif;
    --white: #fff;
    --orange: #fe6b29;
    --green: #7ed321;
    --purple: #bd10e0;
    --blue: #007fff;
    --basetxtcolor: #1E1E1E;
    --baseblue: #231444;
    --whitebg: #fff;
    --greyBorder: #D9D9D9;
    --lightGrey: #BDBDBD;
    --lightsubheading: rgba(15, 15, 15, .40);
    --alerttxt: #E53935;
    --onerem: 1rem;
    --onehalfrem: 1.5rem;
    --tworem: 2rem;
    --fs10: 10px;
    --fs12: 12px;
    --fs14: 14px;
    --fw-100: 100;
    --fw-200: 200;
    --fw-200: 300;
    --fw-400: 400;
    --fw-500: 500;
    --fw-600: 600;
    --fw-700: 700;
    --fw-800: 800;
    --fw-900: 900;
    --midgreen: #1D660F;
}

#root {
    width: 100%
}

body {
    margin: 0;
    padding: 0;
    font-family: var(--fontOpenSans);
    font-weight: normal;
    background: #f8f9fa;
    font-size: 0.875rem;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
}

main {
    min-height: 80vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background-color: #fff;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    font-family: var(--fontBarlow);
    position: relative;
    /* letter-spacing: 0.025rem; */
}

h5 {
    font-weight: var(--fw-600);
    margin-bottom: 0;
    font-size: 1rem;
}

.fw-100 {
    font-weight: var(--fw-100);
}

.fw-200 {
    font-weight: var(--fw-200);
}

.fw-400 {
    font-weight: var(--fw-400);
}

.fw-600 {
    font-weight: var(--fw-600);
}

.fw-700 {
    font-weight: var(--fw-700);
}

.fw-800 {
    font-weight: var(--fw-800);
}

.fw-900 {
    font-weight: var(--fw-900);
}


h1 {
    color: #343a40;
    margin-bottom: 24px;
}

.invalidinput {
    border: 1px solid #dc3545 !important;
}

.p-relative {
    position: relative;
}

.p-absolute {
    position: absolute
}

.l-height14 {
    line-height: 14px;
}

.l-height16 {
    line-height: 16px;
}

.myTopNav {
    background-color: var(--whitebg);
    padding-inline: 0.4rem;
    position: sticky;
    top: 0.5px;
    z-index: 1000;
    /* padding-inline: var(--onerem);
     */
}

.form-control,
.form-select {
    font-family: var(--fontOpenSans);
    border: 2px solid var(--greyBorder);
    font-size: 0.8rem !important;
    line-height: 1.5 !important;
    font-weight: 600;
    min-height: 44px;
}

.categary-select {
    /* line-height: 0.8 !important; */
    min-height: 44px;
    border-end-end-radius: 0px;
    border-start-end-radius: 0px;
    border-radius: 0.375rem;
    border-right: 1px solid #d9d9d9;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.level-select {
    min-height: 44px;
    border-radius: 0.375rem;
    margin-bottom: 5px;
}

.d-block {
    display: block;
}

.onerem {
    font-size: var(--onerem);
}

.label {
    font-family: var(--fontOpenSans);
    font-size: 0.75rem;
    font-weight: 500;
    color: var(--basetxtcolor);
    position: absolute;
    top: -11px;
    background-color: rgb(255, 255, 255);
    padding: 1px 6px;
    left: 8px;
}

input::placeholder,
textarea::placeholder {
    color: var(--lightGrey);
    opacity: 0.2;
    letter-spacing: 0.020rem;
    font-size: 0.6875rem;
    font-weight: 500;
}

.hinttxt {
    background-color: #F2FAFA;
    color: #039C93 !important;
    padding: 4px;
    margin-block: 4px;
    display: inline-block;
    border: 1px solid #e5f7f7;
}

.txt-center {
    text-align: center;
}

.fs-small {
    font-size: var(--fs10);
}


.fs-small12 {
    font-size: var(--fs12);
}


.fs-small14 {
    font-size: var(--fs14);
}

.table>:not(caption)>*>* {
    background-color: transparent;
}

.mytable {
    position: relative;
    color: #1E1E1E;
    font-family: var(--fontOpenSans);
}

.mytable a {
    text-decoration: underline;
    color: #000
}

.mytable a:hover {
    text-decoration: none;
}

.mytable thead th {
    vertical-align: middle;
    border: 2px solid #F0FFF8;
    background: linear-gradient(180deg, #DFFFF0 0%, #F5F5F5 100%);
    font-size: 0.75rem;
    font-weight: var(--fw-700);
    padding-block: 1rem;
    letter-spacing: 0.025rem;
    white-space: nowrap;
}

.mytable tbody td {
    border: 2px solid #F0FFF8;
}

.mytable tbody tr:nth-child(odd) {
    background-color: var(--whitebg)
}

.mytable tr:nth-child(even) {
    background-color: #F8FFFC;
}

.mytable td {
    vertical-align: middle;
    font-size: 0.7rem;
}

.mytable th:last-child,
.mytable td:last-child {
    position: sticky;
}

.tble-thumbnail-icon {
    width: 120px;
    height: 68px;
}

.course-thumbnail-list {
    width: 120px;
    height: 86px;
    border: 1px solid var(--lightGrey);
}

.course-playbtn {
    position: absolute;
    top: 35%;
    left: 40%;
    opacity: 0.8;
    width: 16%;
    z-index: 100;
}

.video-thumnail {
    width: 100%;
    height: 100%;
}

.video-playbtn {
    position: absolute;
    top: 32%;
    left: 32%;
    opacity: 0.8;
    width: 40%
}

.dropdown-menu {
    font-size: 0.875rem;
    line-height: 1.5rem;
    box-shadow: 0px 1px 3px rgba(3, 7, 18, 0.03), 0px 4px 11px rgba(3, 7, 18, 0.05), 0px 10px 24px rgba(3, 7, 18, 0.08);
    border: none;
}

.dropdown-menu .dropdown-item {
    padding-block: .5rem;
    border-bottom: 1px solid #dee2e6;
    display: inline-flex;
    justify-content: left;
    align-items: center;
    gap: 10px;
}

.dropdown-menu .dropdown-item:last-child {
    border-bottom: none;
}

.add-video-container {
    background: var(--whitebg);
    width: 98%;
    border-radius: 1.5rem;
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04);
    padding-block: 1rem;
    padding-inline: 1.5rem;
    margin: 0 auto;
}

.add-video-container h6 {
    font-weight: var(--fw-600);
}

.add-video-bg {
    background: linear-gradient(180deg, #EFFECE 0%, #EDFEE0 27.45%, #EEFCC7 56.42%, #D0F383 100%);
    width: 100%;
    padding-block: var(--onerem);
    padding-inline: var(--onerem);
}

.add-video-bg h4 {
    font-size: 1.25rem;
    white-space: nowrap;
}

.addbtn-small {
    border: 1px solid var(--midgreen);
    color: var(--midgreen);
}

.addbtn-small {
    border: 1px solid var(--midgreen);
    color: var(--midgreen);
    font-size: 0.75rem;
    font-weight: 600;
    white-space: nowrap;
}

.add-assign-btn {
    border: 1px solid var(--midgreen);
    background-color: #fff;
    color: var(--midgreen);
    z-index: 1;
    font-size: 13px;
    font-weight: 700;
    border-radius: 40px;
}

.add-assign-btn:hover,
.add-assign-btn:focus {
    background-color: var(--midgreen);
    border: 1px solid var(--midgreen);
}

.add-reference-btn {
    background: linear-gradient(0deg, #F2F2F2 0%, #EAEAEA 100%), #F2F2F2;
    font-size: 0.6875rem;
    color: var(--baseblue);
    font-weight: var(--fw-600);
    border-radius: 2px;
    border: 1px solid #D9D9D9;
}

.add-reference-btn:hover {
    background: linear-gradient(0deg, #F2F2F2 0%, #EAEAEA 100%), #F2F2F2;
    color: var(--baseblue);
    font-weight: var(--fw-600);
}

.save-btn {
    background: #f26522 !important;
    color: #673417 !important;
    border: none !important;
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 700;
    padding-block: .7rem;
    transition: all .5s;
}

.save-btn:hover {
    color: #673417 !important;
    box-shadow: 0 13px 27px -5px rgb(50 50 93 / 25%), 0 8px 16px -8px rgb(0 0 0 / 30%) !important;
}

.save-btn:hover,
.save-btn:focus {
    background: #d35400 !important;
    color: #673417 !important;
}

.purple-btn:hover {
    color: #fff !important;
}

.p0 {
    padding: 0px;
}

.m0 {
    margin: 0px;
}

.mtop0 {
    margin-top: 0;
}

.mbtm0 {
    margin-bottom: 0;
}

.mbtm8 {
    margin-bottom: .5rem;
}

.whitebg {
    background-color: var(--white);
}

.fleft {
    float: left;
}

.fright {
    float: right;
}

.small-thumb-list {
    width: 120px;
    height: 68px;
}

.purple-btn {
    width: 100%;
    background-color: var(--baseblue);
    color: var(--white);
    border: none;
    transition: all .5s;
}

.purple-btn:hover,
.purple-btn:focus {
    background-color: var(--baseblue);
}

.h44 {
    height: 44px;
}

.ptop0 {
    padding-top: 0;
}

.pright0 {
    padding-right: 0;
}

.pbtm0 {
    padding-bottom: 0;
}

.pleft0 {
    padding-left: 0;
}

.myquestion-bg {
    background-color: #F2FAFA;
    color: #039C93 !important;
    border: 2px solid #D1EAEA !important;
    /* justify-content: center;
     */
    align-items: center;
}

.question-fixer-box {
    height: 96px;
    border: 1px solid #dee2e6;
}

.alert-infobox {
    color: #19325c;
    font-weight: 600;
    margin-bottom: .5rem;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background-color: #ebf3ff;
    padding: .25rem 1rem .25rem .75rem;
    /* border: 1px solid #d0e1f9;
     */
}

.alert-infobox::before {
    content: "\\f05a";
    font-family: var(--Awesome);
    font-size: 1rem;
    margin-right: .5rem;
}

.redtxt {
    color: var(--alerttxt);
}

.course-videolist-pagination {
    position: absolute;
    bottom: -55px;
    right: 0;
    padding: 0;
}

.ans-hint {
    background-color: #FFF9D7;
    color: #F76B1C;
    border: 1px solid #EFE6B0;
}

.add-option-btn {
    background: linear-gradient(0deg, #F2F2F2 0%, #EAEAEA 100%), #F2F2F2;
    font-size: 0.6875rem;
    color: var(--baseblue);
    font-weight: var(--fw-600);
    border-radius: 2px;
    border: 1px solid #D9D9D9;
    cursor: pointer;
}

.add-option-btn:hover {
    background: #eeeded;
    color: var(--baseblue);
    font-weight: var(--fw-600);
}

.slide-in-container {
    position: fixed;
    bottom: 30px;
    left: 10px;
    max-width: 25%;
    transform: translateX(0%);
    transition: transform 0.4s ease-out;
    z-index: 1000;
}

.slide-in-container.visible {
    transform: translateX(100%);
}

.goi-logo {
    position: relative;
    width: 50%;
    display: flex;
    align-items: center;
}

.goi-logo img {
    float: left;
    height: 40px;
    border-right: 0 solid #fff;
    padding-right: 0;
    margin-right: 10px;
    fill: #fff;
}

.goi-logo ul {
    padding: 0;
    margin: 0;
}

.goi-logo li {
    list-style: none;
    display: inline-block;
    font-size: 12px;
    font-weight: 500;
}

.goi-logo li:first-child {
    text-align: right;
}

.goi-logo li:last-child {
    border-left: 1px solid var(--lightGrey);
    padding-inline: 1rem;
    margin-inline: 1rem;
}

.lms-mascotbg {
    background-image: url(https://pmfby.amnex.co.in/pmfby/lms/lms-bg.png);
    /* height: 400px;
     */
    min-height: 473px;
    background-repeat: no-repeat;
    background-position-y: center;
}

.lms-registor-mascotbg {
    background-image: url(https://pmfby.amnex.co.in/pmfby/lms/registration-bg.png);
    min-height: 607px;
}


.login-bg {
    padding: 1rem 2rem 2rem 2rem;
    /* min-height: 461px; */
    min-height: 396px;
    margin-top: 1.25rem;
}

.success-msg {
    background-color: #9EFFD2;
    border: 1px solid #8FE2BB;
    color: #273D0E;
    font-size: 0.6875rem;
    font-weight: var(--fw-600);
    text-align: center;
}

.question-preview-listing {
    background-color: var(--whitebg);
    border-bottom: solid 1px #e9e9e9;
    padding-top: 1rem;
    padding-bottom: 1rem;
    margin-bottom: 1rem;
}

.question-preview-listing:last-child {
    border-bottom: 0;
}

.searchbox-input {
    height: 40px;
    vertical-align: middle;
    padding-top: 0px;
}

.search-icon {
    background: #231444;
}

.search-icon::before {
    content: "\\f002";
    font-family: var(--Awesome);
    color: rgba(33, 33, 33, 0.2);
    position: absolute;
    right: 1.75rem;
    top: 1.7rem;
}

.search-icon2 {
    border: 1px solid #000;
    height: 40px;
    width: 49px;
    position: absolute;
    right: 14px;
    top: 2px;
    background: #231444;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    z-index: 1;
    cursor: pointer;
}

.search-icon2::before {
    content: "\\f002";
    font-family: var(--Awesome);
    font-size: 1rem;
    color: #fff;
    /* color: rgba(33, 33, 33, 0.2);
    position: absolute;
    right: 1.75rem;
    top: 0.6rem; */
}

.mypagination-listing .active>.page-link {
    background-color: #231444;
    border: 1px solid #231444;
}

.invalid-feedback::before {
    content: "\\f06a";
    /* content: "\\f071";
     */
    font-family: var(--Awesome);
    color: var(--bs-form-invalid-color);
    margin-right: .25rem;
}

.list-selected-badge {
    display: inline-flex;
    justify-self: center;
    align-items: center;
    background-color: #3e80c7 !important;
    color: #fff !important;
    font-size: 10px !important;
    font-family: var(--fontOpenSans);
    font-weight: 600;
    border-radius: 2px;
    margin-bottom: .25rem;
}

.card-body {
    padding-top: .5rem;
    min-height: 96px;
}

.progress {
    background-color: #CCCCCC !important;
}

.progress .progress-bar {
    background-color: #231444 !important;
}

.course-listing,
.course-listing-learner,
.publiccourse-listing {
    font-family: var(--fontOpenSans);
    min-height: 280px;
    border: 0;
    margin-bottom: 1rem;
    border: 1px solid var(--greyBorder);
    cursor: pointer;
}

.course-listing:hover {
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    position: absolute;
    z-index: 1;
    transition: all 0.4s ease-in-out;
    width: calc(25% - 1rem);
}

.course-listing-learner:hover {
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    position: absolute;
    z-index: 1;
    transition: all 0.4s ease-in-out;
    width: calc(33% - 1rem);
}

.course-listing:hover .course-card-body,
.course-listing-learner:hover .course-card-body {
    position: relative
}

.course-listing:hover .course-thumbnail-hover,
.course-listing-learner:hover .course-thumbnail-hover {
    display: none;
}

.course-listing:hover .course-thumbnail-hover,
.course-listing-learner:hover .course-thumbnail-hover {
    align-self: start;
    background: rgba(0, 0, 0, 0.5);
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
    display: block;
}

.course-listing:hover .course-thumbnail-hover::before,
.course-listing-learner:hover .course-thumbnail-hover::before {
    height: 208px;
    font-family: var(--Awesome);
    content: "\\f01d";
    position: absolute;
    font-size: 3rem;
    inset: 0;
    margin: 0 auto;
    z-index: 10;
    color: #FAFAFA;
    left: 40%;
    top: 30%;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    box-sizing: border-box;
}

.course-listing:hover .course-thumbnail-hover::after,
.course-listing-learner:hover .course-thumbnail-hover::after {
    height: auto;
    font-family: var(--Awesome);
    content: "";
    position: absolute;
    font-size: 3rem;
    inset: 0;
    transition: opacity 0.3s ease;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    box-sizing: border-box;
}



.course-listing h6,
.publiccourse-listing h6 {
    font-family: var(--fontOpenSans);
    font-size: calc(var(--fs10) + 5px);
    font-weight: var(--fw-600);
    color: #0F0F0F;
}

.course-listing h6::first-letter, 
.publiccourse-listing h6::first-letter {
    text-transform: uppercase;
}


.more-menu-listing {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    position: absolute;
    right: 1rem;
    width: 110px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    padding: .5rem 0;
    z-index: 10000;
    border-radius: 4px;
    bottom: 5px;
}

.more-menu-listing a {
    font-size: calc(var(--fs10) + 4px);
    text-align: left;
    line-height: 1.5rem;
    padding-block: .5rem;
    padding-inline: 1rem;
    -webkit-user-select: none;
    /* Safari */
    -ms-user-select: none;
    /* IE 10 and IE 11 */
    user-select: none;
    /* Standard syntax */
    cursor: pointer;
}

.more-menu-listing a:hover,
.more-menu-listing a:focus {
    background-color: #EFFFF8;
}

.course-status {
    display: inline-block;
    padding: .25rem .5rem;
    border: 1px solid;
    border-radius: 2px;
    font-size: calc(var(--fs10) - 2px);
    font-weight: var(--fw-600);
    letter-spacing: 0.045rem;
    /* margin-bottom: .5rem; */
    text-transform: capitalize;
    min-width: 68px;
    text-align: center;
}

.approve {
    background-color: #cafde5;
    border-color: #b8f3d7;
}

.pending {
    background-color: #fdf2ca;
    border-color: #fbe8a4;
}

.reject {
    background-color: #fdcaca;
    border-color: #f3adad;
}

.public {
    background-color: #6b4ec5;
    color: #fff;
    border-color: #a08dd9;
    white-space: nowrap;
}

.mandate {
    background-color: #c54e4e;
    color: #fff;
    border-color: #c96a6a;
    white-space: nowrap;
}



.card-text {
    font-size: calc(var(--fs10) + 2px);
    font-family: var(--fontOpenSans);
    font-weight: var(--fw-600);
    color: rgba(15, 15, 15, .40);
    text-transform: capitalize;
}

.green-gradient-bg {
    position: relative;
    background-image:
        /* linear-gradient(180deg, #EFFECE 0%, #EDFEE0 27.45%, #EEFCC7 56.42%, #D0F383 100%), */
        url(https://pmfby.amnex.co.in/pmfby/lms/green-gradient-bg.png);
    /* Other background settings */
    min-height: 200px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.h304 {
    /* height: 304px; */
    height: 200px;
}

.new-coursebtn {
    position: absolute;
    top: 40%;
    left: 40%;
    transform: translate(-40%, -40%);
    padding: 20px;
    border-radius: 8px;
}

.new-coursebtn h6 {
    font-family: var(--fontOpenSans);
}

.green-grad-btn {
    font-family: var(--fontOpenSans) !important;
    position: relative;
    display: inline-flex;
    font-size: 0.875rem;
    min-width: 220px;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg, rgb(101, 174, 87) 0%, #D0F382 100%);
    min-height: 64px;
    font-family: var(--fontBarlow);
    font-weight: var(--fw-500);
    border: 1px solid #baeb9d;
    border-radius: 16px;
    color: #1E1E1E;
    box-sizing: border-box;
    transition: all 0.4s ease;
}

.green-grad-btn::before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    width: 48px;
    margin-right: .5rem;
}

.green-grad-btn:hover {
    color: #1E1E1E;
    border: 1px solid #baeb9d;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
}

.green-grad-btn:focus {
    color: #1E1E1E;
    box-shadow: 0 0 10px 4px rgba(101, 174, 87, 0.7);
}

.blue-grad-btn {
    position: relative;
    font-family: var(--fontOpenSans) !important;
    font-size: 0.875rem;
    display: inline-flex;
    justify-content: center;
    min-width: 220px;
    align-items: center;
    /* background: linear-gradient(180deg, rgb(71, 221, 255) 0%, #DCC3FF 100%); */
    background: linear-gradient(180deg, rgb(247, 198, 103) 0%, rgb(240, 232, 156) 100%);
    min-height: 64px;
    font-family: var(--fontBarlow);
    font-weight: var(--fw-500);
    border: 1px solid #F9D88C;
    border-radius: 16px;
    color: #1E1E1E;
    box-sizing: border-box;
    transition: all 0.4s ease;
}

.blue-grad-btn::before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    /* width: 48px; */
    padding-top: .45rem;
    margin-right: .5rem;
}

.blue-grad-btn:hover {
    color: #1E1E1E;
    border: 1px solid #F9D88C;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
}

.blue-grad-btn:focus {
    color: #1E1E1E;
    box-shadow: 0 0 10px 4px rgba(71, 221, 255, 0.7);
}

.purple-grad-btn {
    position: relative;
    font-family: var(--fontOpenSans) !important;
    font-size: 0.875rem;
    display: inline-flex;
    justify-content: center;
    min-width: 220px;
    align-items: center;
    /* background: linear-gradient(180deg, rgb(148, 71, 255) 0%, #FFC3EB 100%); */
    background: linear-gradient(180deg, rgb(214, 164, 203) 0%, rgb(243, 232, 243) 100%);
    min-height: 64px;
    font-family: var(--fontBarlow);
    font-weight: var(--fw-500);
    border: 1px solid #F9D0F1;
    border-radius: 16px;
    color: #1E1E1E;
    box-sizing: border-box;
    transition: all 0.4s ease;
}

.purple-grad-btn::before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    /* width: 48px; */
    padding-top: .5rem;
    margin-right: .5rem;
}

.purple-grad-btn:hover {
    color: #1E1E1E;
    border: 1px solid #F9D0F1;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
}

.purple-grad-btn:focus {
    color: #1E1E1E;
    box-shadow: 0 0 10px 4px rgba(148, 71, 255, 0.7);
}


input[type="search"] {
    min-height: 44px;
    box-sizing: border-box;
    padding: 0 0 0 8px;
    margin: 0;
}

.existing-courselist h6 {
    margin-bottom: 0;
    font-size: calc(var(--fs10) + 6px);
    /* font-size: 1.25rem; */
    font-weight: 600;
    padding-top: .5rem;
}

.btn-close {
    font-size: var(--fs10);
    position: relative;
    right: 10px;
    background-color: #edeaea;
    width: 1em;
    border-radius: 100%;
    height: 1em;
}

.form-check-input:checked[name=loginMethod],
.form-check-input:checked[type=checkbox] {
    background-color: #231444;
    border-color: #231444;
}

.subhead-txt {
    color: var(--lightsubheading);
}

.video-title-container {
    display: flex;
    align-items: center;
    gap: 0.25rem;
}

.status-badge {
    font-size: 0.7rem;
    padding: 0.4em 0.6em;
    border: solid 1px #000;
    border-radius: 20px;
    display: inline-block;
    width: 90px;
    text-align: center;
}

.badge-success {
    border-color: green;
    color: green;
}

.badge-danger {
    border-color: red;
    color: red;
}

.btn-outline-dark {
    border-radius: 10px;
    padding: 0.4em 1em;
    font-size: 0.8rem;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
}

.btn-filled-dark,
.btn-filled-dark:hover,
.btn-filled-dark:active {
    color: #fff !important;
    background-color: #231444 !important;
    border-color: #231444 !important;
    border-radius: 4px;
    padding: 0.75em 1.5em;
    font-size: 0.8rem;
    font-weight: 600;
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
}

input[type="checkbox"] {
    transform: scale(1.2);
}

.video-listing-bg {
    position: relative;
    background-color: #EFFFF8;
    padding: 1rem;
    height: 400px;
    border: 1px solid #D9FFEE;
}



.upload-btn {
    min-width: 90px;
    border: 1px solid #ddd !important;
    color: #333 !important;
    background: #fff !important;
}


.course-thumbnail {
    height: 208px;
    position: relative;
    display: inline-block;
    width: 100%;
    padding-top: calc(6 / 9 * 100%);
    overflow: hidden;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    cursor: pointer;
    box-sizing: border-box;
}




.course-thumbnail img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: fill;
}

.notificationbell i {
    text-decoration: none;
    background: linear-gradient(289deg, rgba(247, 107, 28, 1) 0%, rgba(252, 224, 22, 1) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.notificationbell:hover {
    background-color: #f8f9fa;
}


.notification-count sup {
    background-color: #E83B2D;
    display: inline-flex;
    width: 12px;
    height: 12px;
    position: relative;
    top: -10px;
    font-size: 9px;
    color: #fff;
    justify-content: center;
    align-items: center;
    padding: 8px;
    border-radius: 40px;
}

.usermenu-ddl:hover,
.usermenu-ddl:focus,
.usermenu-ddl:active {
    background-color: #f8f9fa;

}

.usermenu-ddl .btn.show,
.usermenu-ddl .btn:first-child:active {
    background-color: #f8f9fa;
}

.min-h100 {
    min-height: 85vh;
}

a {
    text-decoration: none;
    transition: all .5s;
}

a:hover {
    /* text-decoration: underline; */
    color: #3e68ff;
}

.course-preview-listing {
    position: sticky;
    top: 10px;
    background-color: #EFFFF8;
    padding: 0;
    border: 2px solid #D9FFEE;
    /* min-height: 640px; */
    overflow-x: hidden;
    max-height: 560px;
    overflow-y: auto;
    text-transform: capitalize;
    box-sizing: border-box;
}

.course-preview-listing h5 {
    /* padding-bottom: .5rem; */
    text-transform: math-auto;
}


/* ----------Scrollbar CSS START Here----------- */
.course-preview-listing::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

.course-preview-listing::-webkit-scrollbar-track {
    background: #d6d6d6;
    /* track (background) color */
    border-radius: 10px;
}

.course-preview-listing::-webkit-scrollbar-thumb {
    background: radial-gradient(circle, rgba(238, 174, 202, 1) 0%, rgba(148, 187, 233, 1) 100%);
    /* scrollbar handle color */
    border-radius: 10px;
    height: 12px;
}

/* ----------Scrollbar CSS END Here----------- */


/* .course-preview-listing > div:first-of-type {
    background-color: #DEEAFF;
} */

.course-lessons,
.disable-lessonlist {
    display: flex;
    gap: .5rem;
    cursor: pointer;
    text-decoration: none;
    border-bottom: 1px solid #D9FFEE;
    padding-bottom: .25rem;
    margin-bottom: .5rem;
    padding: .5rem .5rem .5rem 1rem;
}

.disable-lessonlist {
    cursor: not-allowed;
    color: #9A9A9A;
}

.course-lessons:hover {
    background-color: #a0f6ff;
}

.disable-lessonlist:hover {
    background-color: transparent;
}

.course-lessons.active {
    background-color: #a0f6ff;
    border-bottom: 2px solid #231444;
    padding: .5rem .5rem .5rem 1rem;
    margin-bottom: .25rem;
    /* background-color:#DEEAFF; */
    background-color: #a0f6ff;
    padding: .75rem;
    /* padding-inline: .5rem; */
    /* width: 98%; */
    margin: 0 auto;
}

.course-lessons span:nth-child(2),
.disable-lessonlist span:nth-child(2) {
    font-size: 13px;
    color: #333;
    padding-top: 2px;
}

.duration-txt {
    display: flex;
    gap: 56px;
    align-items: center;
    justify-content: space-between;
    color: #9A9A9A;
    font-size: 0.725rem;
    margin-block: .25rem;
    white-space: nowrap;
}

.listed-videos {
    height: 230px;
    overflow-y: scroll;
    overflow-x: hidden;
    padding-top: .5rem;
}

.listed-assessment {
    display: flex;
    justify-content: center;
    max-width: 28px;
    max-height: 28px;
    align-items: center;
    background-color: #d8e4f5;
    border-radius: 4px;

}

.listed-videos-checkbox {
    width: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 28px;
    background-color: #d8e4f5;
    border-radius: 4px;
    margin-top: .25rem;
}

.courselist-toggle {
    position: absolute;
    top: 4%;
    right: 5%;
}

.course-video-view {
    background-color: #16161D;
    padding: 1rem;
    border-radius: 1%;
    max-height: 490px;
}

.course-overview-wrapper {
    margin-block: 1rem;
}

.course-overview-wrapper>h4:first-of-type {
    display: flex;
    align-items: center;
    gap: 1rem;
    font-size: .8rem;
    font-family: var(--fontOpenSans);
    border-bottom: 1px solid #dee2e6;
    /* padding-block: .5rem; */
    /* margin-bottom: 1rem; */
}

.course-overview-wrapper>h4 span:nth-child(1) {
    background-color: #beffd8;
    color: #212529;
    font-weight: var(--fw-600);
    border: 1px solid #ecebeb;
    padding: 1rem;
    min-width: 200px;
}

.course-overview-wrapper>h4 span:nth-child(2),
.course-overview-wrapper>h4 span:nth-child(3) {
    background-color: transparent;
    border: none;
}

.nocourse-addedbox {
    text-align: center;
    border: 1px dashed #a9c2e7;
    padding: .5rem;
    background-color: #ffffff;
    font-size: 12px;
    /* font-weight: 600; */
    letter-spacing: 0.021rem;
    line-height: 1.0rem;
    color: #636972;
}

.v-line {
    position: relative;
}

.v-line::before {
    content: '';
    border: .5px solid #efefef;
    position: absolute;
    z-index: 0;
    height: 100%;
}

.remove-videosbtn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 8px;
    border-radius: 100%;
    width: 24px;
    height: 24px;
}

.dropdown-menu {
    min-width: 220px;
}

.courses-viewbg {
    background-color: #fff;
    /* background-color: #F2F8F2; */
    /* margin-top: .5rem; */
}

.courses-tabcontainer {
    border-bottom: 1px solid #D9D9D9;
    margin-top: .25rem;
    justify-content: center;
    gap: 1rem;
}

.courses-tabcontainer li:first-child {
    display: none;
}

.courses-tabcontainer .nav-link.active {
    font-weight: 900;
    color: #231444;
    border-top: 0;
    border-right: 0;
    border-bottom: 4px solid #231444;
    border-left: 0;
}

.courses-tabcontainer .nav-link {
    color: #231444;
    font-size: 1rem;
    justify-content: center;
    align-items: center;
    display: inline-flex;
    gap: 6px;
}

.courses-tabcontainer .nav-link:hover {
    border-color: transparent;
}

.courses-tabcontainer .nav-item {
    flex-grow: 0;
    width: auto;
    white-space: nowrap;
}

.courses-tabcontainer * .nav-tabs .nav-link:hover {
    border: 0 !important;
}

.course-infohead-section {
    background-color: #e1f7db;
    padding: .5rem 1rem;
    /* margin-left: .10rem; */
    /* width: 98.25%; */
    box-sizing: border-box;
}

.h100percent {
    height: 100%;
}

.course-status-card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    font-family: var(--fontBarlow);
    z-index: 1;
    padding: 0;
}

.course-status-card p {
    font-size: 0.875rem !important;
}

.middle-section {
    /* background-color:var(--whitebg); */
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

.slide-show {
    /* background-image: url(../public/img/slider-1.jpg); */
    /* height: 202px; */
    background-repeat: no-repeat;
    background-size: cover;
}

.learners-tabsinfo {
    background: #2A7B9B;
    background: linear-gradient(180deg, rgba(223, 255, 240, 1) 0%, rgba(245, 245, 245, 1) 100%);
    /* padding-block: .5rem; */
    border: 0;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    display: flex;
    justify-content: center;
    gap: 10rem;
    font-size: .85rem;

}

.learners-tabsinfo * .nav-link {
    color: #231444;
    padding-block: 1rem;
    padding-inline: 2rem;
    box-sizing: border-box;
    border: 0;
    transition: all .5s;
}

.learners-tabsinfo * .nav-link:hover,
.learners-tabsinfo * .nav-link:focus {
    border: 0;
    border-color: transparent;
}

.learners-tabsinfo * .nav-link.active {
    background-color: #231444;
    color: #fff;
    font-weight: var(--fw-700);
    border: 0;
    box-sizing: border-box;
    padding-block: 1rem;
    padding-inline: 2rem;
    border-color: transparent;
}

.learner-rightside-widgetbox {
    min-height: 320px;
    /* height: 100vh; */
    border: 2px solid;
    border-image: linear-gradient(180deg, rgba(222, 255, 255, 1) 0%, rgba(245, 245, 245, 1) 100%);
    border-image-slice: 1;
    border-radius: 1.5rem;
    margin-bottom: 1rem;
    box-sizing: border-box;
    padding: .5rem;
}

.learner-rightside-widgetbox h6 {
    font-size: 1.20rem;
    background: linear-gradient(180deg, #FCE016, #F76B1C);
    /* your gradient */
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    /* Optional for better compatibility */
    background-clip: text;
    color: transparent;
}

.certificate-infobox {
    margin-block: 1rem;
}

.certificate-infobox h5 {
    font-family: var(--fontOpenSans);
    font-size: 0.75rem;
}

.certificate-infobox span {
    font-size: 0.625rem;
    color: rgba(15, 15, 15, .40);
}

.my-innermenu {
    gap: 1rem;
}

.my-innermenu .dropdown {
    min-height: 40px;
}

.my-innermenu .dropdown:hover {
    background-color: #f8f9fa;
}

.my-innermenu * .btn-light {
    background-color: transparent;
}

.question-list-container {
    height: 70vh;
    padding: 1rem;
    padding-inline: 1rem !important;
    background-color: #fff;
    overflow-y: scroll;
}

.question-list-container h4 {
    font-size: 1.3rem;
    font-weight: var(--fw-600);
}

.question-list-container h4::before {
    content: "Quiz Title :- ";
}


/* ----------Scrollbar CSS START Here----------- */
.question-list-container::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

.question-list-container::-webkit-scrollbar-track {
    background: #d6d6d6;
    /* track (background) color */
    border-radius: 10px;
}

.question-list-container::-webkit-scrollbar-thumb {
    background: linear-gradient(rgba(253, 29, 29, 1) 50%, rgba(252, 176, 69, 1) 100%);
    /* scrollbar handle color */
    border-radius: 10px;
    height: 12px;
}

/* ----------Scrollbar CSS END Here----------- */

.quiz-box {
    /* box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; */
    border: 0 !important;
}

.quiz-box .card-body {
    background-color: #F5FEF9;
    border: 1px solid #dcefe6;
    border-radius: 12px;
    font-size: 13px;
    /* padding: 1.5rem; */
    padding-block: 1rem;
    padding-left: 1rem;
    padding-right: 2rem;
    max-height: initial;
}

.quiz-box .list-group-item {
    background-color: transparent;
    margin-top: .5rem;
}

.quiz-box .list-group-item .row {
    align-items: center;
}

.quiz-box .list-group-item .col-md-1 {
    justify-content: center;
    display: flex;
}

.quiz-box .list-group-item .col-md-1 .form-check {
    display: flex;
    gap: .5rem;
}

.quiz-box .list-group-item .col-md-11 {
    background-color: #fff;
    font-weight: 500;
    border: 1px solid #DEE2E1;
    border-radius: 8px;
    padding-block: .5rem;

}

.middle-content {
    background-color: #fff;
    min-height: calc(100vh - 175px);
    padding-block: 1rem;
    box-sizing: border-box;
    font-family: var(--fontOpenSans);
    box-shadow: 0 12px 16px 2px rgba(0, 0, 0, .1);
    padding-inline: 2rem;
}

.middle-content h4 {
    font-size: calc(var(--fs10) + 10px);
}

.middle-content p {
    text-align: justify;
    font-size: .85rem;
    padding-top: 10px;
    line-height: 1.5rem;
}

.page-heading {
    border-bottom: 1px solid #b8e986;
    padding-bottom: 1rem;
}

.inner-bg {
    background-image: url(https://pmfby.amnex.co.in/pmfby/lms/inner-pages-bg.jpg);
}

.assign-course-list,
.already-assigned-courselist {
    position: relative;
    padding: .5rem;
    width: 98%;
    margin: 0 auto;
}

.assign-course-list h5,
.already-assigned-courselist h5 {
    margin-bottom: .5rem;
}

.assign-course-list img,
.already-assigned-courselist img {
    width: 120px;
    height: 84px;
    border-radius: 4px;
}

.added-badge,
.newly-added-badge {
    position: absolute;
    color: #fff;
    font-size: 10px;
    font-weight: 500;
    right: 0;
    width: 64px;
    text-align: center;
    padding-block: .25rem;

}

.added-badge {
    background: #2A7B9B;
    background-image: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    top: 0px;
}

.newly-added-badge {
    background: #833AB4;
    background-image: linear-gradient(to right, #fa709a 0%, #fee140 100%);
    top: 0;
    z-index: 20;
}


.add-arrow-btn,
.unassign-arrowbtn {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    border-radius: 4px;
    cursor: pointer;
    text-align: center;
    transition-duration: 0.4s;
    text-decoration: none;
    overflow: hidden;
}

.add-arrow-btn {
    background-color: #1D660F;
}

.unassign-arrowbtn {
    background-color: #f16557;

}


.course-count {
    color: #3673a7;
}

.new-course-count {
    color: #fd9620;
}

.course-Document {
    cursor: pointer;
    text-decoration: none;
    border-bottom: 1px solid #D9FFEE;
    padding: .5rem .5rem .5rem 0.5rem;
    font-weight: bold;
}

.course-Document:hover {
    background-color: #a0f6ff;
}

/* ----------Scrollbar CSS START Here----------- */
.listing-newscroll::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

.listing-newscroll::-webkit-scrollbar-track {
    background: #D9D9D9;
    /* track (background) color */
    border-radius: 10px;
}

.listing-newscroll::-webkit-scrollbar-thumb {
    background: radial-gradient(circle, rgba(238, 174, 202, 1) 0%, rgba(148, 187, 233, 1) 100%);
    /* scrollbar handle color */
    border-radius: 10px;
    height: 12px;
}

/* ----------Scrollbar CSS END Here----------- */




/* ----------Landing Page CSS START Here----------- */

.top-navbar {
    background: linear-gradient(90deg, #65AE57 0%, #2A4824 100%);
}

.top-navbar.navbar {
    min-height: 44px;
    padding-top: .15rem;
    padding-bottom: .15rem;
}

.top-navbar .container-fluid {
    min-height: 38px;
}

.top-navbar .nav-link {
    color: #fff;
    display: flex;
    justify-content: left;
    gap: 8px;
    align-items: center;
    font-size: .86rem;
    line-height: 1.15;
    padding-top: .25rem;
    padding-bottom: .25rem;
    transition: all .5s;
}

.top-navbar .nav-link:hover,
.top-navbar .nav-link * i:hover {
    background: linear-gradient(0deg, #F0E89C 0%, #F7C667 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.top-navbar .nav-link.active {
    color: #fff;

}

.top-navbar .dropdown-menu {
    color: #010101;
}

.hero-slider {
    position: relative;
    background-color: #f9f9f9;
    /* border-bottom: 1px solid #D1F385; */
}

.hero-slider-img {
    height: 300px;
}

.slider {
    height: 300px;
    overflow: hidden;
}

.slider img {
    width: 100%;
    height: 300px;
    object-fit: cover;
    object-position: center;
}

.count-stats {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 96%;
    height: auto;
    flex-shrink: 0;
    border-radius: 28px;
    padding: .65rem 1rem .8rem;
    border: 1px solid #F3FFD8;
    margin: 0 auto;
    background: linear-gradient(90deg, #8CFF23 0%, #CDFE78 32.52%, #D7FC9C 58.8%, #AFFC9C 100%);
}

.count-list {
    display: inline-flex;
    align-items: center;
    gap: 5rem;
    color: #231444;
    justify-content: space-evenly;
    padding: 0;
    margin: 0;
}

.count-list li {
    display: flex;
    align-items: center;
    justify-self: center;
    font-size: .78rem;
    line-height: 1.2;
    width: 148px;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}

.count-list li .icon {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #231444;
    width: 3rem;
    height: 3rem;
    border-radius: 40px;
}

.count-list li .icon svg {
    max-width: 1.35rem;
    max-height: 1.35rem;
}

.count-list li .count {
    font-family: var(--fontBarlow);
    font-weight: 800;
    font-size: 1.45rem;
    line-height: 1.05;
    margin-top: .15rem;
}

.count-list li span:nth-child(2) {
    display: flex;
    flex-direction: column;
}

.about-lms {
    position: relative;
    z-index: 0;
    /* margin-top: 5rem; */
    padding-block: 2rem;
    color: #47444E;
}

.about-imgbox {
    text-align: center;
}

.about-lms-grid {
    align-items: flex-start;
}

.about-lms-main {
    padding-right: 1.25rem;
}

.about-lms-main .about-imgbox img {
    max-width: 240px;
    width: 100%;
}

.about-events-panel {
    padding-left: 1.25rem;
    border-left: 1px solid #edf0ee;
}

.about-lms p,
.course-container p {
    line-height: 1.6rem;
}

.course-container ul {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6rem;
}

.hightligh-link {
    background: linear-gradient(0deg, #F0E89C 0%, #F7C667 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: 800;
    font-size: calc(var(--fs10) + 6px);
    transition: all .5s;
}


.card-scrolling {
    background-color: #fff;
    /* padding: 1rem; */
    border: 2px solid #EFEFEF;
    border-radius: .75rem;
}


.primary-linktxt,
.secondary-linktxt {
    text-decoration: underline;
    transition: all .5s;
}

.primary-linktxt {
    color: #F76B1C;
}

.secondary-linktxt {
    color: #231444;
}


.mandatory-marked {
    display: inline-block;
    background-color: #FFDCC8;
    color: #F76B1C !important;
    padding: .5rem;
    border-radius: 100px;
    text-decoration: none !important;
    text-align: center;
    white-space: nowrap;
    min-width: 96px;
}

.mandatory-marked:hover,
.public-marked:hover {
    text-decoration: none;
    color: inherit;
}


.public-marked {
    display: inline-block;
    background-color: #E9DFFF;
    color: #231444 !important;
    padding: .5rem;
    border-radius: 100px;
    text-decoration: none !important;
    text-align: center;
    white-space: nowrap;
    min-width: 96px;
}

.main-container {
    min-height: calc(100vh - 130px);
    /* 60px header + 70px footer */
}

.start-info,
.last-view-info {
    font-size: 11px;
    line-height: 16px;
}


.hamburger {
    display: none;
    font-size: 12px;
    background: #db8516;
    color: #fff;
    border: none;
    padding: 8px 12px;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    z-index: 1001;
}

#courselist {
    display: block;
}


/* Course Tracking Module CSS START Here*/
.count-card-bg {
    background-color: #EFFFF8;
    padding-block: 1rem;
    vertical-align: middle;
    margin-bottom: 2rem;
}

.count-card-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 3rem;
    height: 3rem;
    border-radius: 40px;
}

.total-icon {
    background-color: #9B7BE2;
}

.complete-icon {
    background-color: #7EBF58;
}

.inprocess-icon {
    background-color: #B2983A;
}

.pending-icon {
    background-color: #E95A5C;
}

.count-card-container {
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 2px solid;
    border-radius: 1rem;
    padding: .5rem;
    box-shadow: 0 10px 27px -5px rgb(50 50 93 / 15%), 0 8px 8px -8px rgb(0 0 0 / 13%) !important;
}


.total {
    border-color: #9B7BE2;
}

.complete {
    border-color: #A2E57B;
}

.inprocess {
    border-color: #FAD961;
}

.pending {
    border-color: #E95A5C;
}


.count-card-container .count-no {
    font-family: var(--fontBarlow);
    font-size: 1.5rem;
    font-weight: var(--fw-700);
}

.summary-container {
    line-height: 32px;
    vertical-align: middle;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: rgba(30, 30, 30, 0.9);
}


.summary-txt {
    display: block;
    font-size: 2.5rem;
    font-weight: var(--fw-700);
}

.approve-course-heading {
    margin-bottom: 3rem;
}

.approve-course-container {
    height: 150px;
    margin-bottom: 100px;
}


/* Course Tracking Module CSS END Here*/


/* ----------Landing Page CSS END Here----------- */
.hide-menu,
.show-menu {
    position: absolute;
    background-color: #424e78;
    /* width: 72px; */

    cursor: pointer;
    /* border: 1px solid #000; */
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding-block: 0.25rem;
    /* top: 4px; */
    box-sizing: border-box;
    /* border-top-left-radius: 100px;
    border-bottom-left-radius: 100px; */
    color: #fff;
    flex: 0 0 auto;
    /* width: 6%; */
    width: 2%;
    z-index: 100;
    box-shadow: rgba(100, 100, 111, 0.5) 0px 7px 29px 0px;
    transition: all .05s;
}

.hide-menu {
    left: 16.6%;
}

.show-menu {
    left: 1px;
}

.left-menu-links {
    display: flex;
    gap: 8px;
    justify-content: flex-start;
    align-items: center;
    color: rgb(35, 20, 68);
    white-space: nowrap;
    padding-block: 0.5rem;
    margin-top: 0.5rem;
}

.left-menu-hd {
    font-weight: 700;
    color: rgb(35, 20, 68);
    padding-top: 1rem;
    padding-left: 1rem;
    font-size: 0.875rem !important;
}


.form-check {
    display: inline-flex;
    gap: 0.65rem;
}

.form-check-input:checked {
    transform: scale(1.3);
    /* 1.2–1.5 is ideal */
}


.left-menu-panel {
    min-height: 100vh;
    border: 1px solid #cccccc;
    padding: 0;
    position: relative;
}

.left-menu-panel * .active {
    background-color: #2D9152;
    color: #ffffff;
}

.btn-inline-border {
    /* border-right: 1px solid #dee2e6; */
    border-left: 1px solid #dee2e6;
    color: #0d6efd;
}

.pagination {
    justify-content: end;
}

.pagination .page-item {
    margin-left: .25rem;
    border: 1px solid #dee2e6;
    margin: 0px;
}

.pagination .page-item .btn {
    color: #231444;
    font-size: .875rem;
    padding: .5rem .75rem;
    border-radius: 0px;
}

/* Blink Circle Online Users START Here */

.online-user {
    font-family: var(--fontOpenSans) !important;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    border: 1px solid #9df3cb;
    border-radius: 100px;
    padding: 5px 8px;
    background-color: #d0ffe9;
    margin: 0px !important;
}

.online-txt {
    display: inline-flex;
    justify-content: space-around;
    align-items: end;
    gap: 4px;
    color: #616161;
}

.activeuser-count {
    font-weight: 600;
    font-size: 14px;
    color: #00350E;
}

.online-user .circle,
.online-user .circle::before {
    content: " ";
    margin: 15px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin: 0 auto;
    transition: all 0.1s;
    background-color: #00FF00;
}

.circle::before {
    animation: mymove 2s infinite;
    position: absolute;
    background-color: #00350E
}

@-webkit-keyframes mymove {
    50% {
        transform: scale(2.5);
        opacity: 0
    }

    100% {
        transform: scale(2.5);
        opacity: 0
    }
}


.blinker-homepge,
.blinker-homepge::before {
    position: absolute;
    right: 10px;
    top: 15px;
    content: " ";
    margin: 15px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin: 0 auto;
    transition: all 0.1s;
    background-color: #00FF00;
}

.blinker-homepge::before {
    animation: mymove2 2s infinite;
    position: absolute;
    background-color: #b6fbc8;
    right: 0px;
    top: 0px;

}

@-webkit-keyframes mymove2 {
    50% {
        transform: scale(2.5);
        opacity: 0
    }

    100% {
        transform: scale(2.5);
        opacity: 0
    }
}

/* Blink Circle Online Users END Here */

.mobile-links {
    display: none;
}


/* Hide Seek Bar and Time Display in Video Controls */
.hide-seek-bar::-webkit-media-controls-timeline {
    display: none !important;
}

.hide-seek-bar::-webkit-media-controls-seek-back-button,
.hide-seek-bar::-webkit-media-controls-seek-forward-button {
    display: none !important;
}

/* .hide-seek-bar::-webkit-media-controls-current-time-display,
.hide-seek-bar::-webkit-media-controls-time-remaining-display {
  display: none !important;
} */


.footer-bottom-link {
    display: flex;
    justify-content: center;
    margin-block: .5rem;
    align-items: center;
    gap: 1rem;

}

.footer-bottom-link small:nth-child(1) {
    line-height: 14px;
    border-right: 1px solid #fff;
    padding-right: 1rem;
}

.footer-bottom-link small:nth-child(2) {
    display: flex;
    gap: 8px;
    justify-content: center;
}

.report-card-container {
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.report-graph-container {
    background-color: #fff;
    padding: 1rem;
    height: 430px;
}

.report-graph-container canvas {
    margin: 0 auto;
    width: 100% !important;
    height: 100% !important;
}

/* swiper custom class start */

.custom-swiper {
    position: relative;
    /* padding-bottom: 40px; */
}
.custom-swiper .swiper {
    padding-bottom: 20px;
}
.custom-swiper .swiper .swiper-pagination-bullets{
    bottom: 0;
}
.custom-swiper .swiper-pagination {
    position: absolute;
    bottom: 0 ;
    left: 0;
    width: 100%;
    text-align: center;
}

.custom-swiper .swiper-pagination-bullet {
    background: none;
    border: solid 2px #34A853;
    opacity: 1;
    width: 16px;
    height: 16px;
}

.custom-swiper .swiper-pagination-bullet-active {
    background: #34A853;
}

.custom-swiper .swiper-button-prev,
.custom-swiper .swiper-button-next {
    background-color: #3f8d42;
    border-radius: 4px;
    padding: 10px;
    border:none;
    color: #fff;
    top: 42% !important;
    transform: translateY(-42%);
    margin-top: 0!important;
    min-height: 55px;
}
.custom-swiper .swiper-button-prev{
    left: 0.3rem;
}
.custom-swiper .swiper-button-next {
    right: 0.3rem !important;
    
}

/* swiper custom class end */

/* Profile page */
.profile-page {
    background: #f8faf7;
    min-height: calc(100vh - 72px);
    padding: 1.5rem;
}

.profile-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 1320px;
    margin: 0 auto 1rem;
}

.profile-header h4 {
    margin: 0;
    color: #111827;
    font-family: var(--fontOpenSans);
    font-size: 1.4rem;
    font-weight: 800;
}

.profile-header p,
.profile-panel-title span {
    color: #667085;
    font-size: .88rem;
    font-weight: 600;
    margin: .25rem 0 0;
}

.profile-page > .row {
    max-width: 1320px;
    margin-left: auto;
    margin-right: auto;
    align-items: stretch;
}

.profile-page > .row > [class*="col-"] {
    display: flex;
    align-self: stretch;
}

.profile-panel {
    background: #fff;
    border: 1px solid #dde6df;
    border-radius: 8px;
    box-shadow: 0 4px 14px rgba(17, 24, 39, 0.06);
    padding: 1rem 1.05rem;
    margin-bottom: 1rem;
    width: 100%;
    height: calc(100%);
    min-height: 430px;
    display: flex;
    flex-direction: column;
}

.profile-panel-title {
    border-bottom: 1px solid #edf0ee;
    margin: 0 -1.05rem .85rem;
    padding: 0 1.05rem .7rem;
}

.profile-panel-title h5 {
    color: #182033;
    font-size: 1rem;
    font-weight: 800;
    margin: 0;
}

.profile-panel .label {
    color: #2f3a4a;
    font-weight: 700;
}

.profile-panel .form-control,
.profile-panel .form-select {
    min-height: 38px;
    border-color: #d7dfda;
    color: #1f2937;
    font-weight: 600;
}

.profile-panel .form-control[readonly] {
    background: #f6f8f7;
    color: #5f6b7a;
}

.profile-loading {
    max-width: 1320px;
    margin: 0 auto;
    padding: 1rem;
    border: 1px solid #dde6df;
    border-radius: 8px;
    background: #fff;
    color: #475467;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: .5rem;
}

.profile-overview {
    max-width: 1320px;
    margin: 0 auto 1rem;
    display: grid;
    grid-template-columns: auto minmax(0, 1fr) minmax(240px, 320px);
    align-items: center;
    gap: 1rem;
    padding: 1rem;
    border: 1px solid #dfe8e1;
    border-radius: 8px;
    background: linear-gradient(180deg, #ffffff 0%, #f8fbf8 100%);
    box-shadow: 0 8px 22px rgba(17, 24, 39, 0.07);
}

.profile-avatar {
    width: 76px;
    height: 76px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    background: linear-gradient(135deg, #2d9152 0%, #83c56b 100%);
    color: #fff;
    font-family: var(--fontBarlow);
    font-size: 1.65rem;
    font-weight: 800;
    box-shadow: inset 0 0 0 4px rgba(255, 255, 255, 0.32);
}

.profile-overview-main {
    min-width: 0;
}

.profile-overview-title h5 {
    color: #111827;
    font-family: var(--fontOpenSans);
    font-size: 1.18rem;
    font-weight: 800;
    line-height: 1.3;
    margin: 0;
}

.profile-overview-title span {
    display: block;
    color: #64748b;
    font-size: .86rem;
    font-weight: 600;
    margin-top: .2rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.profile-meta-list {
    display: flex;
    flex-wrap: wrap;
    gap: .5rem;
    margin-top: .85rem;
}

.profile-meta-list span {
    display: inline-flex;
    align-items: center;
    gap: .45rem;
    min-height: 32px;
    padding: .35rem .65rem;
    border: 1px solid #e1ebe4;
    border-radius: 999px;
    background: #fff;
    color: #344054;
    font-size: .78rem;
    font-weight: 700;
}

.profile-meta-list i {
    color: #2d9152;
    font-size: .85rem;
}

.profile-completion {
    padding: .8rem;
    border: 1px solid #e1ebe4;
    border-radius: 8px;
    background: #fff;
}

.profile-completion-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: .75rem;
    margin-bottom: .65rem;
}

.profile-completion-label span {
    color: #475467;
    font-size: .78rem;
    font-weight: 800;
}

.profile-completion-label strong {
    color: #1d660f;
    font-size: .95rem;
}

.profile-progress {
    height: 8px;
    overflow: hidden;
    border-radius: 999px;
    background: #e7efe8;
}

.profile-progress span {
    display: block;
    height: 100%;
    border-radius: inherit;
    background: linear-gradient(90deg, #2d9152, #f26522);
    transition: width .25s ease;
}

.profile-panel {
    border-color: #dfe8e1;
    box-shadow: 0 8px 22px rgba(17, 24, 39, 0.06);
    transition: box-shadow .2s ease, border-color .2s ease;
}

.profile-panel:hover {
    border-color: #cddfd2;
    box-shadow: 0 12px 28px rgba(17, 24, 39, 0.09);
}

.profile-panel-title {
    display: flex;
    align-items: flex-start;
    gap: .65rem;
}

.profile-panel-icon {
    width: 34px;
    height: 34px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    background: #edf8ef;
    color: #2d7f45;
    border: 1px solid #d7eedb;
}

.profile-panel-icon i {
    font-size: 1rem;
}

.profile-subsection {
    display: flex;
    align-items: center;
    gap: .55rem;
    margin: .2rem 0 .75rem;
}

.profile-subsection span {
    color: #152033;
    font-size: .78rem;
    font-weight: 800;
    text-transform: uppercase;
}

.profile-subsection::after {
    content: "";
    height: 1px;
    flex: 1;
    background: #edf0ee;
}

.profile-panel .mb-3 {
    margin-bottom: .85rem !important;
}

.profile-panel .form-control,
.profile-panel .form-select {
    border-width: 1px;
    border-radius: 6px;
    background-color: #fff;
    transition: border-color .2s ease, box-shadow .2s ease, background-color .2s ease;
}

.profile-panel .form-control:focus,
.profile-panel .form-select:focus {
    border-color: #2d9152;
    box-shadow: 0 0 0 .18rem rgba(45, 145, 82, 0.14);
}

.profile-panel .form-control[readonly] {
    border-style: dashed;
}

.profile-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: auto;
    padding-top: .25rem;
}

.profile-actions .save-btn {
    min-width: 170px;
    min-height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: .5rem;
    border-radius: 6px;
}

.profile-actions .save-btn:disabled {
    background: #d8dee3 !important;
    color: #667085 !important;
    box-shadow: none !important;
    cursor: not-allowed;
}

.profile-side-panel .profile-actions .save-btn {
    width: 100%;
}

.profile-side-panel {
    min-height: 100%;
}

.profile-side-panel .profile-panel-title {
    margin-bottom: .65rem;
}

.profile-side-panel .mb-3 {
    margin-bottom: .7rem !important;
}

.profile-inline-warning {
    margin: -.25rem 0 .9rem;
    padding: .6rem .75rem;
    border: 1px solid #ffd6a8;
    border-radius: 6px;
    background: #fff8ef;
    color: #9a4d10;
    font-size: .78rem;
    font-weight: 700;
}

.password-strength-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: .25rem .55rem;
    margin: -.2rem 0 .7rem;
    padding: .45rem .55rem;
    border: 1px solid #e4e9e5;
    border-radius: 6px;
    background: #fbfcfb;
}

.password-strength-list span {
    display: inline-flex;
    align-items: center;
    gap: .35rem;
    color: #667085;
    font-size: .7rem;
    font-weight: 700;
    line-height: 1.2;
}

.password-strength-list i {
    color: #98a2b3;
    font-size: .78rem;
}

.password-strength-list span.valid {
    color: #1d660f;
}

.password-strength-list span.valid i {
    color: #2d9152;
}

/* LMS home refresh */
.lms-home-page {
    background: #f8faf7;
    min-height: calc(100vh - 72px);
    padding: 1.35rem 1rem 1.5rem;
    overflow-x: clip;
}

.lms-home-hero {
    display: block;
    max-width: 1720px;
    margin: 0 auto;
    padding: 0;
    position: relative;
}

.lms-home-hero .slide-show {
    margin: 0;
}

.loginCarousel img {
    width: 100%;
    height: 170px;
    object-fit: cover;
    object-position: center;
}

.loginCarousel .swiper-button-prev,
.loginCarousel .swiper-button-next {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 52px;
    background: #3f8d42;
    opacity: 1;
    border-radius: 5px;
    z-index: 5;
    color: #fff;
    padding: 12px;
    border:none;
    top: 42%;
    transform: translateY(-42%);
    margin-top: 0;
}

.loginCarousel .swiper-button-prev {
    left: 2rem;
}

.loginCarousel .swiper-button-next {
    right: 2rem;
}

.loginCarousel .swiper-pagination-bullet {
    width: 30px;
    height: 4px;
    border: 0;
    border-radius: 99px;
    background-color: rgba(255, 255, 255, 0.5);
    opacity: 1;
}

.loginCarousel .swiper-pagination-bullet-active {
    background-color: rgba(255, 255, 255, 1);
}

.lms-role-actions {
    margin: 0;
    position: relative;
}

.lms-role-actions .new-coursebtn {
    position: static;
    top: auto;
    left: auto;
    transform: none;
    margin: .85rem 0 0;
    padding: .9rem 1rem;
    border: 1px solid #dfeee2;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 8px 20px rgba(32, 75, 45, 0.08);
}

.lms-role-actions .new-coursebtn.green-gradient-bg {
    background-image: url(https://pmfby.amnex.co.in/pmfby/lms/green-gradient-bg.png);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.lms-home-hero>.lms-role-actions:first-child .new-coursebtn {
    margin-top: 0;
}

.lms-role-actions h6 {
    margin-bottom: .75rem;
    color: #18351f;
    font-family: var(--fontOpenSans);
    font-size: 1.18rem;
    font-weight: 800;
    line-height: 1.35;
    letter-spacing: 0;
}

.lms-role-actions .small {
    color: #405c46;
    font-size: .9rem;
    font-weight: 600;
    line-height: 1.45;
}

.lms-banner-action {
    min-height: 38px;
    margin: .25rem .35rem;
    border-radius: 6px;
    font-weight: 700;
}

.lms-home-content {
    max-width: 1720px;
    margin: 1.1rem auto 0;
    padding-left: 0 !important;
    padding-right: 0 !important;
}

.lms-home-main,
.lms-home-side {
    padding-left: .5rem;
    padding-right: .5rem;
}

.lms-home-content>.row,
.course-toolbar,
.course-grid {
    margin-left: 0;
    margin-right: 0;
}

.course-toolbar,
.course-grid {
    width: 100%;
}

.learners-tabsinfo {
    background: #f1f3f1;
    border: 0;
    border-radius: 6px;
    display: flex;
    gap: 0;
    justify-content: stretch;
    min-height: 52px;
    overflow: hidden;
}

.learners-tabsinfo .nav-item {
    flex: 1 1 0;
}

.learners-tabsinfo .nav-link {
    width: 100%;
    height: 52px;
    color: #172033;
    border: 0;
    border-radius: 0;
    font-weight: 700;
    padding: .9rem 1rem;
}

.learners-tabsinfo .nav-link:hover,
.learners-tabsinfo .nav-link:focus {
    border: 0;
    color: #1d5929;
}

.learners-tabsinfo .nav-link.active {
    background: #3f7e3f;
    color: #fff;
    border: 0;
    border-radius: 5px;
}

.course-toolbar {
    align-items: center;
    gap: .75rem 0;
    margin: .95rem 0 0;
}

.course-toolbar-title h6 {
    margin: 0;
    color: #121826;
    font-size: 1.12rem;
    font-weight: 800;
    line-height: 1.3;
    letter-spacing: 0;
}

.course-toolbar-title span {
    display: block;
    color: #667085;
    font-size: .82rem;
    font-weight: 600;
    line-height: 1.35;
    margin-top: .15rem;
}

.course-search .form-control {
    height: 48px !important;
    border: 1px solid #dde3df;
    border-radius: 6px !important;
    box-shadow: 0 2px 8px rgba(17, 24, 39, 0.04);
    color: #1f2937;
    font-size: .9rem;
    font-weight: 600;
}

.course-search .form-control::placeholder {
    color: #8a94a6;
    font-weight: 500;
}

.course-search .search-icon2 {
    right: 12px;
    top: 0;
    width: 48px;
    height: 48px;
    border-radius: 0 6px 6px 0;
    background: #3f7e3f;
}

.course-search .search-icon2::before {
    color: #fff;
    left: 16px;
    top: 12px;
}

.course-view-switcher {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0;
}

.course-view-switcher span {
    height: 48px;
    display: inline-flex;
    align-items: center;
    padding: 0 .8rem;
    border: 1px solid #dde3df;
    border-right: 0;
    border-radius: 6px 0 0 6px;
    background: #fff;
    color: #1f2937;
    font-size: .86rem;
    font-weight: 800;
}

.course-view-switcher .btn {
    width: 42px;
    height: 48px;
    border: 1px solid #dde3df;
    border-radius: 0;
    background: #fff;
    color: #263238;
    padding: 0;
}

.course-view-switcher .btn:last-child {
    border-radius: 0 6px 6px 0;
}

.course-view-switcher .btn.active,
.course-view-switcher .btn:hover {
    background: #3f7e3f;
    border-color: #3f7e3f;
    color: #fff;
}

.course-grid {
    margin-top: 1.5rem;
    overflow: visible;
}

.course-card {
    margin-bottom: 1.4rem;
    position: relative;
    overflow: visible;
}

.course-card:hover {
    z-index: 30;
}

.course-listing,
.course-listing-learner {
    min-height: 0;
    height: 100%;
    border: 1px solid #dfe6e1;
    border-radius: 7px;
    overflow: hidden;
    box-shadow: 0 4px 14px rgba(17, 24, 39, 0.06);
    transition: transform .2s ease, box-shadow .2s ease;
}

.course-grid:not(.course-grid-list) .course-listing:hover,
.course-grid:not(.course-grid-list) .course-listing-learner:hover {
    position: relative;
    width: 100%;
    transform: scale(1.035);
    box-shadow: 0 12px 26px rgba(17, 24, 39, 0.13);
    overflow: visible;
    z-index: 30;
}

.course-grid-list .course-listing:hover,
.course-grid-list .course-listing-learner:hover {
    position: relative;
    width: 100%;
    transform: none;
    box-shadow: 0 12px 26px rgba(17, 24, 39, 0.13);
    overflow: visible;
    z-index: 30;
}

.course-thumbnail {
    height: 214px;
    padding-top: 0;
    background: #edf2ed;
    overflow: hidden;
}

.course-thumbnail img {
    width: 100%;
    object-fit: cover;
}

.course-card-body {
    padding: .75rem 1rem .85rem;
    position: relative;
}

.course-status {
    display: inline-flex;
    align-items: center;
    min-height: 18px;
    border-radius: 2px;
    padding: 0 .6rem;
    margin-bottom: .35rem;
    background: #5645b8;
    color: #fff;
    font-size: .68rem;
    font-weight: 800;
    text-transform: capitalize;
    letter-spacing: .01rem;
}

.course-status.public,
.course-status.mandate {
    background: #5645b8;
    color: #fff;
}

.course-status.approve {
    background: #cafde5;
    border-color: #b8f3d7;
    color: #17351f;
}

.course-listing h6,
.course-listing-learner h6 {
    color: #182033;
    font-family: var(--fontOpenSans);
    font-size: .98rem;
    font-weight: 800;
    line-height: 1.28;
    letter-spacing: 0;
    text-transform: none;
}

.course-listing .card-text,
.course-listing-learner .card-text {
    color: #5f6b7a;
    font-family: var(--fontOpenSans);
    font-size: .82rem;
    font-weight: 500;
    min-height: 20px;
    line-height: 1.5;
    letter-spacing: 0;
    text-transform: none;
}

.start-info,
.last-view-info {
    color: #2f3a4a;
    font-family: var(--fontOpenSans);
    font-size: .78rem;
    font-weight: 600;
    line-height: 1.55;
    letter-spacing: 0;
}

.course-card small {
    color: #3f4858;
    font-size: .74rem;
    font-weight: 500;
}

.course-hover-details {
    display: none;
    position: absolute;
    left: .75rem;
    right: .75rem;
    top: 2.55rem;
    z-index: 40;
    max-height: none;
    overflow: visible;
    padding: .75rem .85rem;
    border: 1px solid #dfe6e1;
    border-radius: 6px;
    background: #fff;
    box-shadow: 0 16px 34px rgba(17, 24, 39, 0.18);
}

.course-hover-details h6 {
    margin: 0 0 .35rem;
    color: #111827;
    font-size: 1rem;
    font-weight: 800;
    line-height: 1.3;
}

.course-hover-details p {
    margin: 0;
    color: #566173;
    font-size: .84rem;
    font-weight: 500;
    line-height: 1.5;
    text-transform: none;
}

.course-listing:hover .course-hover-details,
.course-listing-learner:hover .course-hover-details {
    display: block;
}

.course-listing-learner:hover h6,
.course-grid-list .course-listing-learner h6 {
    font-size: 1rem;
    line-height: 1.3;
}

.course-listing-learner:hover .card-text,
.course-grid-list .course-listing-learner .card-text {
    color: #566173;
    font-size: .84rem;
    font-weight: 500;
    line-height: 1.48;
    text-transform: none;
}

.course-grid-list .course-listing,
.course-grid-list .course-listing-learner {
    display: grid;
    grid-template-columns: 280px minmax(0, 1fr);
}

.course-grid-list .course-thumbnail {
    height: 100%;
    min-height: 190px;
    background: #f4f7f4;
}

.course-grid-list .course-thumbnail img {
    object-fit: contain;
}

.course-grid-compact .course-thumbnail {
    height: 170px;
}

.learner-rightside-widgetbox {
    min-height: 100%;
    border: 1px solid #dde6df;
    border-radius: 8px;
    background: #fff;
    padding: 1rem 1rem .25rem;
    box-shadow: 0 4px 14px rgba(17, 24, 39, 0.05);
}

.learner-rightside-widgetbox h6 {
    margin: 0 -1rem .75rem;
    padding: 0 1rem .8rem;
    border-bottom: 1px solid #edf0ee;
    font-size: 1.02rem;
    font-weight: 800;
    line-height: 1.35;
    background: linear-gradient(180deg, #ffb51f, #f46f18);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.certificate-infobox {
    margin: 0 -1rem;
    padding: .75rem 1rem;
    border-bottom: 1px solid #edf0ee;
    align-items: center;
}

.certificate-infobox img {
    border: 1px solid #f1c94a;
    border-radius: 2px;
}

.certificate-infobox h5 {
    color: #172033;
    font-size: .84rem;
    font-weight: 800;
    line-height: 1.35;
    margin-bottom: .4rem;
}

.certificate-infobox span,
.certificate-empty {
    color: #5f6b7a;
    font-size: .76rem;
    font-weight: 600;
}
.togel-password{
    position: absolute;
    z-index: 10;
    right: 0;
    top: 0;
    height: 44px;
    border-radius: 0px 5px 5px 0px;
    background-color: #ffffff;
}

/* Training events */
.training-events-public-wrap {
    background: #fff;
    padding: 2rem 0 .75rem;
}

.lms-home-events {
    max-width: 1720px;
    margin: 0 auto 1.1rem;
}

.training-events-section {
    width: 100%;
}

.training-events-compact .training-events-header {
    margin-bottom: .75rem;
}

.training-events-compact .training-events-grid {
    row-gap: 0;
}

.training-events-compact .training-events-grid > [class*="col-"] {
    flex: 0 0 100%;
    max-width: 100%;
    margin-bottom: 1rem;
}

.training-events-compact .training-events-grid > [class*="col-"]:last-child {
    margin-bottom: 0;
}

.training-events-compact .training-event-card,
.training-events-compact .training-event-skeleton {
    min-height: 0;
    margin-bottom: 0;
}

.training-events-compact .training-event-thumb {
    height: 104px;
}

.training-events-compact .training-event-body {
    min-height: 142px;
    padding: .75rem .85rem .85rem;
}

.training-events-compact .training-event-body h5 {
    font-size: .92rem;
}

.training-events-sidebar {
    margin-bottom: 1rem;
}

.training-events-sidebar .training-events-grid {
    row-gap: 1rem;
}

.training-events-sidebar .training-events-header {
    margin-bottom: .75rem;
}

.training-events-sidebar .training-events-header h4 {
    font-size: 1rem;
}

.training-events-sidebar .training-events-header p {
    font-size: .74rem;
    line-height: 1.35;
}

.training-events-sidebar .training-events-grid > [class*="col-"] {
    flex: 0 0 100%;
    max-width: 100%;
    margin-bottom: 0;
}

.training-events-sidebar .training-events-grid > [class*="col-"]:last-child {
    margin-bottom: 0;
}

.training-events-sidebar .training-event-card,
.training-events-sidebar .training-event-skeleton {
    min-height: 0;
    margin-bottom: 0;
}

.training-events-sidebar .training-event-thumb {
    height: 112px;
}

.training-events-sidebar .training-event-body {
    min-height: 144px;
    padding: .75rem .85rem .85rem;
}

.training-events-sidebar .training-event-body h5 {
    font-size: .92rem;
}

.training-events-header {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1rem;
}

.training-events-header h4 {
    color: #172033;
    font-family: var(--fontOpenSans);
    font-size: 1.22rem;
    font-weight: 800;
    line-height: 1.3;
    margin: 0;
    animation: trainingHeadingFlash 1.8s ease-in-out infinite;
}

@keyframes trainingHeadingFlash {
    0%,
    100% {
        color: #172033;
        text-shadow: none;
    }
    50% {
        color: #f26522;
        text-shadow: 0 0 10px rgba(242, 101, 34, 0.28);
    }
}

.training-events-header p {
    color: #667085;
    font-size: .86rem;
    font-weight: 600;
    line-height: 1.45;
    margin: .2rem 0 0;
}

.training-events-grid {
    gap: 0;
}

.training-event-card {
    height: 100%;
    min-height: 316px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-bottom: 1rem;
    border: 1px solid #dfe6e1;
    border-radius: 7px;
    background: #fff;
    box-shadow: 0 4px 14px rgba(17, 24, 39, 0.06);
}

.training-event-thumb {
    height: 142px;
    background: #edf2ed;
    overflow: hidden;
}

.training-event-thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.training-event-body {
    min-height: 174px;
    display: flex;
    flex-direction: column;
    padding: .85rem .95rem .95rem;
}

.training-event-meta {
    display: flex;
    flex-wrap: wrap;
    gap: .45rem .8rem;
    min-height: 22px;
    color: #526071;
    font-size: .74rem;
    font-weight: 700;
    line-height: 1.35;
    text-transform: capitalize;
}

.training-event-meta i {
    color: #3f7e3f;
    margin-right: .25rem;
}

.training-event-body h5 {
    color: #172033;
    font-family: var(--fontOpenSans);
    font-size: 1rem;
    font-weight: 800;
    line-height: 1.3;
    margin: .55rem 0 .35rem;
}

.training-event-body p {
    color: #5f6b7a;
    font-size: .82rem;
    font-weight: 500;
    line-height: 1.48;
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.training-event-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: .75rem;
    margin-top: auto;
    padding-top: .9rem;
}

.training-event-type {
    min-height: 24px;
    display: inline-flex;
    align-items: center;
    padding: 0 .65rem;
    border: 1px solid #d7eedb;
    border-radius: 4px;
    background: #edf8ef;
    color: #225b2d;
    font-size: .72rem;
    font-weight: 800;
    text-transform: capitalize;
}

.training-event-action {
    min-height: 34px;
    border: 0 !important;
    border-radius: 5px;
    background: #f26522 !important;
    color: #fff !important;
    font-size: .78rem;
    font-weight: 800;
    padding: .35rem .8rem;
    white-space: nowrap;
}

.training-event-action:hover,
.training-event-action:focus {
    background: #d35400 !important;
    color: #fff !important;
}

.training-event-skeleton {
    position: relative;
    min-height: 316px;
    background: linear-gradient(90deg, #eef3ef 25%, #f7faf8 37%, #eef3ef 63%);
    background-size: 400% 100%;
    animation: trainingEventSkeleton 1.3s ease infinite;
}

@keyframes trainingEventSkeleton {
    0% {
        background-position: 100% 0;
    }
    100% {
        background-position: 0 0;
    }
}

@media (max-width: 767px) {
    .about-lms-main {
        padding-right: 0;
    }

    .about-events-panel {
        padding-left: 0;
        border-left: 0;
        margin-top: 1rem;
    }

    .training-events-public-wrap {
        padding: 1.25rem .75rem .25rem;
    }

    .lms-home-events {
        margin-bottom: .75rem;
    }

    .training-events-header {
        align-items: flex-start;
        flex-direction: column;
    }

    .training-event-card,
    .training-event-skeleton {
        min-height: 300px;
    }

    .training-event-thumb {
        height: 132px;
    }

    .training-event-footer {
        align-items: flex-start;
        flex-direction: column;
    }
}

/* Training event admin */
.training-admin-page {
    padding: 1rem;
}

.training-admin-form,
.training-admin-list {
    border: 1px solid #dfe6e1;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 4px 14px rgba(17, 24, 39, 0.06);
    margin-bottom: 1rem;
    padding: 1rem;
}

.training-admin-form h4 {
    color: #172033;
    font-family: var(--fontOpenSans);
    font-size: 1.18rem;
    font-weight: 800;
    line-height: 1.3;
    margin: 0;
}

.training-admin-form h4 + span,
.training-admin-list h6 + span {
    color: #667085;
    display: block;
    font-size: .82rem;
    font-weight: 600;
    margin-top: .15rem;
}

.training-admin-flags {
    display: flex;
    flex-direction: column;
    gap: .55rem;
    justify-content: center;
}

.training-admin-flags .form-check-label {
    color: #172033;
    font-size: .84rem;
    font-weight: 700;
}

.training-admin-flags small {
    color: #667085;
    display: block;
    font-size: .72rem;
    font-weight: 600;
    overflow-wrap: anywhere;
}

.training-admin-list h6 {
    color: #172033;
    font-family: var(--fontOpenSans);
    font-size: 1rem;
    font-weight: 800;
    margin: 0;
}

.training-admin-event-cell {
    display: grid;
    grid-template-columns: 82px minmax(0, 1fr);
    gap: .75rem;
    align-items: center;
    min-width: 320px;
}

.training-admin-thumb {
    width: 82px;
    height: 52px;
    object-fit: cover;
    border: 1px solid #dde6df;
    border-radius: 5px;
    background: #edf2ed;
}

.training-admin-event-cell strong {
    color: #172033;
    display: block;
    font-size: .82rem;
    font-weight: 800;
    line-height: 1.3;
}

.training-admin-event-cell span {
    color: #667085;
    display: block;
    font-size: .72rem;
    font-weight: 700;
    line-height: 1.4;
    text-transform: capitalize;
}

.training-admin-status {
    min-width: 76px;
    min-height: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    font-size: .72rem;
    font-weight: 800;
    text-transform: capitalize;
}

.training-admin-status.draft {
    background: #fdf2ca;
    color: #7a4d00;
}

.training-admin-status.published {
    background: #cafde5;
    color: #17351f;
}

.training-admin-status.cancelled {
    background: #fdcaca;
    color: #7a1f1f;
}

.training-admin-status.completed {
    background: #e7ebf0;
    color: #344054;
}

.training-admin-actions {
    display: inline-flex;
    gap: .35rem;
    align-items: center;
}

.training-admin-actions .btn {
    width: 32px;
    height: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 1px solid #dde6df;
    border-radius: 5px;
    background: #fff;
    color: #263238;
}

.training-admin-actions .btn:hover:not(:disabled),
.training-admin-actions .btn:focus:not(:disabled) {
    background: #3f7e3f;
    border-color: #3f7e3f;
    color: #fff;
}

.training-admin-actions .btn:disabled {
    background: #f2f4f3;
    color: #98a2b3;
    cursor: not-allowed;
}

@media (max-width: 767px) {
    .training-admin-page {
        padding: .75rem;
    }

    .training-admin-event-cell {
        min-width: 280px;
    }
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;IAGI,wBAAwB;IACxB,UAAU;IACV,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,kCAAkC;;AAEtC;;AAEA;IACI,kCAAkC;IAClC,uCAAuC;IACvC,oCAAoC;IACpC,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,oBAAoB;IACpB,wCAAwC;IACxC,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,aAAa;IACb,aAAa;IACb,aAAa;IACb,aAAa;IACb,aAAa;IACb,aAAa;IACb,aAAa;IACb,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;IACV,gCAAgC;IAChC,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mCAAmC;IACnC,kCAAkC;IAClC,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;;;;;;IAMI,8BAA8B;IAC9B,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;;AAGA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,sBAAsB;IACtB,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb;MACE;AACN;;AAEA;;IAEI,gCAAgC;IAChC,mCAAmC;IACnC,4BAA4B;IAC5B,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;IAC5B,uBAAuB;IACvB,+BAA+B;IAC/B,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,UAAU;IACV,oCAAoC;IACpC,gBAAgB;IAChB,SAAS;AACb;;AAEA;;IAEI,uBAAuB;IACvB,YAAY;IACZ,wBAAwB;IACxB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;;AAGA;IACI,sBAAsB;AAC1B;;;AAGA;IACI,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,6DAA6D;IAC7D,kBAAkB;IAClB,0BAA0B;IAC1B,mBAAmB;IACnB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,mHAAmH;IACnH,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,gCAAgC;IAChC,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,UAAU;IACV,qBAAqB;IACrB,0CAA0C;IAC1C,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6FAA6F;IAC7F,WAAW;IACX,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;IACtB,sBAAsB;IACtB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,iCAAiC;IACjC,iCAAiC;AACrC;;AAEA;IACI,oEAAoE;IACpE,oBAAoB;IACpB,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,oEAAoE;IACpE,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,6FAA6F;AACjG;;AAEA;;IAEI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,iCAAiC;IACjC,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,oCAAoC;IACpC;MACE;IACF,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,kCAAkC;IAClC;MACE;AACN;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,oEAAoE;IACpE,oBAAoB;IACpB,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,UAAU;IACV,cAAc;IACd,yBAAyB;IACzB,mCAAmC;IACnC,aAAa;AACjB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uCAAuC;IACvC,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,qEAAqE;IACrE;MACE;IACF,iBAAiB;IACjB,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,8EAA8E;IAC9E,iBAAiB;AACrB;;;AAGA;IACI,4BAA4B;IAC5B,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,oBAAoB;IACpB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,4BAA4B;IAC5B,kBAAkB;IAClB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;IACf,WAAW;IACX;;;kBAGc;AAClB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB;MACE;IACF,2BAA2B;IAC3B,mCAAmC;IACnC,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,oCAAoC;IACpC,sBAAsB;IACtB,0BAA0B;IAC1B,gCAAgC;IAChC,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;IAGI,gCAAgC;IAChC,iBAAiB;IACjB,SAAS;IACT,mBAAmB;IACnB,mCAAmC;IACnC,eAAe;AACnB;;AAEA;IACI,iDAAiD;IACjD,kBAAkB;IAClB,UAAU;IACV,gCAAgC;IAChC,uBAAuB;AAC3B;;AAEA;IACI,iDAAiD;IACjD,kBAAkB;IAClB,UAAU;IACV,gCAAgC;IAChC,uBAAuB;AAC3B;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,iBAAiB;IACjB,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,OAAO;IACP,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,QAAQ;IACR,cAAc;IACd,WAAW;IACX,cAAc;IACd,SAAS;IACT,QAAQ;IACR,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;;IAEI,YAAY;IACZ,2BAA2B;IAC3B,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,QAAQ;IACR,6BAA6B;IAC7B,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;AAC1B;;;;AAIA;;IAEI,gCAAgC;IAChC,kCAAkC;IAClC,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;AAC7B;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iDAAiD;IACjD,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,yBAAyB;IACzB,WAAW;IACX,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,kCAAkC;IAClC,0BAA0B;IAC1B,wBAAwB;IACxB,0BAA0B;IAC1B,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;AACvB;;;;AAIA;IACI,kCAAkC;IAClC,gCAAgC;IAChC,0BAA0B;IAC1B,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB;;sEAEkE;IAClE,8BAA8B;IAC9B,iBAAiB;IACjB,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,uEAAuE;IACvE,gBAAgB;IAChB,8BAA8B;IAC9B,0BAA0B;IAC1B,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,gDAA8C;IAC9C,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,cAAc;IACd,gDAAgD;AACpD;;AAEA;IACI,kBAAkB;IAClB,2CAA2C;IAC3C,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,6EAA6E;IAC7E,mFAAmF;IACnF,gBAAgB;IAChB,8BAA8B;IAC9B,0BAA0B;IAC1B,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,gDAAiD;IACjD,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,cAAc;IACd,gDAAgD;AACpD;;AAEA;IACI,kBAAkB;IAClB,2CAA2C;IAC3C,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,6EAA6E;IAC7E,mFAAmF;IACnF,gBAAgB;IAChB,8BAA8B;IAC9B,0BAA0B;IAC1B,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,gDAAgD;IAChD,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,cAAc;IACd,gDAAgD;AACpD;;;AAGA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,UAAU;IACV,mBAAmB;IACnB,WAAW;AACf;;AAEA;;IAEI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;;;IAGI,sBAAsB;IACtB,oCAAoC;IACpC,gCAAgC;IAChC,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,yBAAyB;AAC7B;;;;AAIA;IACI,eAAe;IACf,iCAAiC;IACjC,sBAAsB;IACtB,2BAA2B;AAC/B;;;AAGA;IACI,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,+BAA+B;IAC/B,gBAAgB;IAChB,2BAA2B;IAC3B,4BAA4B;IAC5B,eAAe;IACf,sBAAsB;AAC1B;;;;;AAKA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,yFAAyF;IACzF,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;;;IAGI,yBAAyB;;AAE7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,yBAAyB;IACzB,UAAU;IACV,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;AAC7B;;;AAGA,kDAAkD;AAClD;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,2FAA2F;IAC3F,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;AAChB;;AAEA,gDAAgD;;;AAGhD;;GAEG;;AAEH;;IAEI,aAAa;IACb,UAAU;IACV,eAAe;IACf,qBAAqB;IACrB,gCAAgC;IAChC,sBAAsB;IACtB,oBAAoB;IACpB,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;IAChC,+BAA+B;IAC/B,qBAAqB;IACrB,8BAA8B;IAC9B,yBAAyB;IACzB,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;;AAEtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,gCAAgC;IAChC,gCAAgC;IAChC,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,0BAA0B;IAC1B,yBAAyB;IACzB,aAAa;IACb,gBAAgB;AACpB;;AAEA;;IAEI,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,sBAAsB;IACtB,wBAAwB;IACxB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,+BAA+B;IAC/B,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,eAAe;IACf,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,8BAA8B;IAC9B,UAAU;IACV,UAAU;AACd;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;IACrC,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,uDAAuD;IACvD,mBAAmB;IACnB,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,2FAA2F;IAC3F,0BAA0B;IAC1B,SAAS;IACT,2BAA2B;IAC3B,4BAA4B;IAC5B,aAAa;IACb,uBAAuB;IACvB,UAAU;IACV,iBAAiB;;AAErB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;;IAEI,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,0BAA0B;IAC1B,SAAS;IACT,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,6FAA6F;IAC7F,qBAAqB;IACrB,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,qDAAqD;IACrD,kBAAkB;IAClB,6BAA6B;IAC7B,oCAAoC;;IAEpC,sCAAsC;IACtC,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,+BAA+B;IAC/B,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA,kDAAkD;AAClD;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,iFAAiF;IACjF,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;AAChB;;AAEA,gDAAgD;;AAEhD;IACI,uDAAuD;IACvD,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;;AAExB;;AAEA;IACI,sBAAsB;IACtB,+BAA+B;IAC/B,mBAAmB;IACnB,sBAAsB;IACtB,gCAAgC;IAChC,6CAA6C;IAC7C,oBAAoB;AACxB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,6EAA6E;AACjF;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,cAAc;AAClB;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;;IAEI,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,QAAQ;IACR,WAAW;IACX,kBAAkB;IAClB,qBAAqB;;AAEzB;;AAEA;IACI,mBAAmB;IACnB,mEAAmE;IACnE,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,qEAAqE;IACrE,MAAM;IACN,WAAW;AACf;;;AAGA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;;AAE7B;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,gCAAgC;IAChC,iCAAiC;IACjC,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,kDAAkD;AAClD;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,2FAA2F;IAC3F,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;AAChB;;AAEA,gDAAgD;;;;;AAKhD,qDAAqD;;AAErD;IACI,4DAA4D;AAChE;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;;IAEI,2DAA2D;IAC3D,qBAAqB;IACrB,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,WAAW;;AAEf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,0BAA0B;IAC1B,yBAAyB;IACzB,cAAc;IACd,2FAA2F;AAC/F;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,6BAA6B;IAC7B,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,8BAA8B;AAClC;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,2DAA2D;IAC3D,qBAAqB;IACrB,6BAA6B;IAC7B,oCAAoC;IACpC,gBAAgB;IAChB,kCAAkC;IAClC,mBAAmB;AACvB;;;AAGA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;AACzB;;;AAGA;;IAEI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,oBAAoB;IACpB,gCAAgC;IAChC,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,qBAAqB;IACrB,cAAc;AAClB;;;AAGA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,oBAAoB;IACpB,gCAAgC;IAChC,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;;AAGA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;;AAGA,yCAAyC;AACzC;IACI,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,4FAA4F;AAChG;;;AAGA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;;AAGA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;AAChC;;;AAGA;IACI,cAAc;IACd,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;;AAGA,uCAAuC;;;AAGvC,mDAAmD;AACnD;;IAEI,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;;IAEjB,eAAe;IACf,4BAA4B;IAC5B,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,sBAAsB;IACtB,cAAc;IACd,sBAAsB;IACtB;uCACmC;IACnC,WAAW;IACX,cAAc;IACd,eAAe;IACf,SAAS;IACT,YAAY;IACZ,qDAAqD;IACrD,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,2BAA2B;IAC3B,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;AAClC;;;AAGA;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;AACzB;;;AAGA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA,yCAAyC;;AAEzC;IACI,2CAA2C;IAC3C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,yBAAyB;IACzB,oBAAoB;IACpB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,6BAA6B;IAC7B,gBAAgB;IAChB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;AACJ;;;AAGA;;IAEI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,QAAQ;;AAEZ;;AAEA;IACI;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;AACJ;;AAEA,uCAAuC;;AAEvC;IACI,aAAa;AACjB;;;AAGA,qDAAqD;AACrD;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;;;GAGG;;;AAGH;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;;AAEb;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA,8BAA8B;;AAE9B;IACI,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,oBAAoB;AACxB;AACA;IACI,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI,wBAAwB;;AAE5B;;AAEA,4BAA4B;;AAE5B,iBAAiB;AACjB;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,6CAA6C;IAC7C,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,+DAA+D;IAC/D,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,6DAA6D;IAC7D,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,6DAA6D;IAC7D,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,qDAAqD;AACzD;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,sBAAsB;IACtB,oDAAoD;IACpD,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;IAC7C,sDAAsD;AAC1D;;AAEA;IACI,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,OAAO;IACP,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,iFAAiF;AACrF;;AAEA;;IAEI,qBAAqB;IACrB,gDAAgD;AACpD;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,aAAa;IACb,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;IACX,SAAS;IACT,mBAAmB;IACnB,0CAA0C;IAC1C,UAAU;AACd;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,6CAA6C;AACjD;;AAEA;IACI,gFAAgF;IAChF,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;;IAEI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;;;IAGI,cAAc;IACd,eAAe;AACnB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,aAAa;IACb,MAAM;IACN,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;IAC7B,4CAA4C;IAC5C,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,MAAM;IACN,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,MAAM;AACV;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,6CAA6C;IAC7C,mDAAmD;AACvD;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,8CAA8C;IAC9C,iBAAiB;IACjB,WAAW;AACf;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,8CAA8C;IAC9C,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;;IAEI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;;IAEI,cAAc;IACd,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;;IAEI,cAAc;IACd,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;;IAEI,cAAc;IACd,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;;IAEI,aAAa;IACb,2CAA2C;AAC/C;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,6CAA6C;AACjD;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,qDAAqD;IACrD,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;;IAEI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,MAAM;IACN,YAAY;IACZ,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA,oBAAoB;AACpB;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,yDAAyD;AAC7D;;AAEA;IACI;;QAEI,cAAc;QACd,iBAAiB;IACrB;IACA;QACI,cAAc;QACd,8CAA8C;IAClD;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,8BAA8B;IAC9B,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;;IAEI,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,yEAAyE;IACzE,0BAA0B;IAC1B,mDAAmD;AACvD;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;IAC1B;AACJ;;AAEA,yBAAyB;AACzB;IACI,aAAa;AACjB;;AAEA;;IAEI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,6CAA6C;IAC7C,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;AACb;;AAEA;;IAEI,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,0CAA0C;IAC1C,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["*,\n*::before,\n*::after {\n    outline: none !important;\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n}\n\nhtml {\n    position: relative;\n    font-size: 1rem;\n    height: 100%;\n    text-rendering: optimizeLegibility;\n\n}\n\n:root {\n    --fontBarlow: \"Barlow\", sans-serif;\n    --fontOpenSans: \"Open Sans\", sans-serif;\n    --Awesome: \"FontAwesome\", sans-serif;\n    --white: #fff;\n    --orange: #fe6b29;\n    --green: #7ed321;\n    --purple: #bd10e0;\n    --blue: #007fff;\n    --basetxtcolor: #1E1E1E;\n    --baseblue: #231444;\n    --whitebg: #fff;\n    --greyBorder: #D9D9D9;\n    --lightGrey: #BDBDBD;\n    --lightsubheading: rgba(15, 15, 15, .40);\n    --alerttxt: #E53935;\n    --onerem: 1rem;\n    --onehalfrem: 1.5rem;\n    --tworem: 2rem;\n    --fs10: 10px;\n    --fs12: 12px;\n    --fs14: 14px;\n    --fw-100: 100;\n    --fw-200: 200;\n    --fw-200: 300;\n    --fw-400: 400;\n    --fw-500: 500;\n    --fw-600: 600;\n    --fw-700: 700;\n    --fw-800: 800;\n    --fw-900: 900;\n    --midgreen: #1D660F;\n}\n\n#root {\n    width: 100%\n}\n\nbody {\n    margin: 0;\n    padding: 0;\n    font-family: var(--fontOpenSans);\n    font-weight: normal;\n    background: #f8f9fa;\n    font-size: 0.875rem;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    text-rendering: optimizeLegibility;\n}\n\nmain {\n    min-height: 80vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    background-color: #fff;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    font-family: var(--fontBarlow);\n    position: relative;\n    /* letter-spacing: 0.025rem; */\n}\n\nh5 {\n    font-weight: var(--fw-600);\n    margin-bottom: 0;\n    font-size: 1rem;\n}\n\n.fw-100 {\n    font-weight: var(--fw-100);\n}\n\n.fw-200 {\n    font-weight: var(--fw-200);\n}\n\n.fw-400 {\n    font-weight: var(--fw-400);\n}\n\n.fw-600 {\n    font-weight: var(--fw-600);\n}\n\n.fw-700 {\n    font-weight: var(--fw-700);\n}\n\n.fw-800 {\n    font-weight: var(--fw-800);\n}\n\n.fw-900 {\n    font-weight: var(--fw-900);\n}\n\n\nh1 {\n    color: #343a40;\n    margin-bottom: 24px;\n}\n\n.invalidinput {\n    border: 1px solid #dc3545 !important;\n}\n\n.p-relative {\n    position: relative;\n}\n\n.p-absolute {\n    position: absolute\n}\n\n.l-height14 {\n    line-height: 14px;\n}\n\n.l-height16 {\n    line-height: 16px;\n}\n\n.myTopNav {\n    background-color: var(--whitebg);\n    padding-inline: 0.4rem;\n    position: sticky;\n    top: 0.5px;\n    z-index: 1000;\n    /* padding-inline: var(--onerem);\n     */\n}\n\n.form-control,\n.form-select {\n    font-family: var(--fontOpenSans);\n    border: 2px solid var(--greyBorder);\n    font-size: 0.8rem !important;\n    line-height: 1.5 !important;\n    font-weight: 600;\n    min-height: 44px;\n}\n\n.categary-select {\n    /* line-height: 0.8 !important; */\n    min-height: 44px;\n    border-end-end-radius: 0px;\n    border-start-end-radius: 0px;\n    border-radius: 0.375rem;\n    border-right: 1px solid #d9d9d9;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.level-select {\n    min-height: 44px;\n    border-radius: 0.375rem;\n    margin-bottom: 5px;\n}\n\n.d-block {\n    display: block;\n}\n\n.onerem {\n    font-size: var(--onerem);\n}\n\n.label {\n    font-family: var(--fontOpenSans);\n    font-size: 0.75rem;\n    font-weight: 500;\n    color: var(--basetxtcolor);\n    position: absolute;\n    top: -11px;\n    background-color: rgb(255, 255, 255);\n    padding: 1px 6px;\n    left: 8px;\n}\n\ninput::placeholder,\ntextarea::placeholder {\n    color: var(--lightGrey);\n    opacity: 0.2;\n    letter-spacing: 0.020rem;\n    font-size: 0.6875rem;\n    font-weight: 500;\n}\n\n.hinttxt {\n    background-color: #F2FAFA;\n    color: #039C93 !important;\n    padding: 4px;\n    margin-block: 4px;\n    display: inline-block;\n    border: 1px solid #e5f7f7;\n}\n\n.txt-center {\n    text-align: center;\n}\n\n.fs-small {\n    font-size: var(--fs10);\n}\n\n\n.fs-small12 {\n    font-size: var(--fs12);\n}\n\n\n.fs-small14 {\n    font-size: var(--fs14);\n}\n\n.table>:not(caption)>*>* {\n    background-color: transparent;\n}\n\n.mytable {\n    position: relative;\n    color: #1E1E1E;\n    font-family: var(--fontOpenSans);\n}\n\n.mytable a {\n    text-decoration: underline;\n    color: #000\n}\n\n.mytable a:hover {\n    text-decoration: none;\n}\n\n.mytable thead th {\n    vertical-align: middle;\n    border: 2px solid #F0FFF8;\n    background: linear-gradient(180deg, #DFFFF0 0%, #F5F5F5 100%);\n    font-size: 0.75rem;\n    font-weight: var(--fw-700);\n    padding-block: 1rem;\n    letter-spacing: 0.025rem;\n    white-space: nowrap;\n}\n\n.mytable tbody td {\n    border: 2px solid #F0FFF8;\n}\n\n.mytable tbody tr:nth-child(odd) {\n    background-color: var(--whitebg)\n}\n\n.mytable tr:nth-child(even) {\n    background-color: #F8FFFC;\n}\n\n.mytable td {\n    vertical-align: middle;\n    font-size: 0.7rem;\n}\n\n.mytable th:last-child,\n.mytable td:last-child {\n    position: sticky;\n}\n\n.tble-thumbnail-icon {\n    width: 120px;\n    height: 68px;\n}\n\n.course-thumbnail-list {\n    width: 120px;\n    height: 86px;\n    border: 1px solid var(--lightGrey);\n}\n\n.course-playbtn {\n    position: absolute;\n    top: 35%;\n    left: 40%;\n    opacity: 0.8;\n    width: 16%;\n    z-index: 100;\n}\n\n.video-thumnail {\n    width: 100%;\n    height: 100%;\n}\n\n.video-playbtn {\n    position: absolute;\n    top: 32%;\n    left: 32%;\n    opacity: 0.8;\n    width: 40%\n}\n\n.dropdown-menu {\n    font-size: 0.875rem;\n    line-height: 1.5rem;\n    box-shadow: 0px 1px 3px rgba(3, 7, 18, 0.03), 0px 4px 11px rgba(3, 7, 18, 0.05), 0px 10px 24px rgba(3, 7, 18, 0.08);\n    border: none;\n}\n\n.dropdown-menu .dropdown-item {\n    padding-block: .5rem;\n    border-bottom: 1px solid #dee2e6;\n    display: inline-flex;\n    justify-content: left;\n    align-items: center;\n    gap: 10px;\n}\n\n.dropdown-menu .dropdown-item:last-child {\n    border-bottom: none;\n}\n\n.add-video-container {\n    background: var(--whitebg);\n    width: 98%;\n    border-radius: 1.5rem;\n    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04);\n    padding-block: 1rem;\n    padding-inline: 1.5rem;\n    margin: 0 auto;\n}\n\n.add-video-container h6 {\n    font-weight: var(--fw-600);\n}\n\n.add-video-bg {\n    background: linear-gradient(180deg, #EFFECE 0%, #EDFEE0 27.45%, #EEFCC7 56.42%, #D0F383 100%);\n    width: 100%;\n    padding-block: var(--onerem);\n    padding-inline: var(--onerem);\n}\n\n.add-video-bg h4 {\n    font-size: 1.25rem;\n    white-space: nowrap;\n}\n\n.addbtn-small {\n    border: 1px solid var(--midgreen);\n    color: var(--midgreen);\n}\n\n.addbtn-small {\n    border: 1px solid var(--midgreen);\n    color: var(--midgreen);\n    font-size: 0.75rem;\n    font-weight: 600;\n    white-space: nowrap;\n}\n\n.add-assign-btn {\n    border: 1px solid var(--midgreen);\n    background-color: #fff;\n    color: var(--midgreen);\n    z-index: 1;\n    font-size: 13px;\n    font-weight: 700;\n    border-radius: 40px;\n}\n\n.add-assign-btn:hover,\n.add-assign-btn:focus {\n    background-color: var(--midgreen);\n    border: 1px solid var(--midgreen);\n}\n\n.add-reference-btn {\n    background: linear-gradient(0deg, #F2F2F2 0%, #EAEAEA 100%), #F2F2F2;\n    font-size: 0.6875rem;\n    color: var(--baseblue);\n    font-weight: var(--fw-600);\n    border-radius: 2px;\n    border: 1px solid #D9D9D9;\n}\n\n.add-reference-btn:hover {\n    background: linear-gradient(0deg, #F2F2F2 0%, #EAEAEA 100%), #F2F2F2;\n    color: var(--baseblue);\n    font-weight: var(--fw-600);\n}\n\n.save-btn {\n    background: #f26522 !important;\n    color: #673417 !important;\n    border: none !important;\n    font-size: 14px;\n    text-transform: uppercase;\n    font-weight: 700;\n    padding-block: .7rem;\n    transition: all .5s;\n}\n\n.save-btn:hover {\n    color: #673417 !important;\n    box-shadow: 0 13px 27px -5px rgb(50 50 93 / 25%), 0 8px 16px -8px rgb(0 0 0 / 30%) !important;\n}\n\n.save-btn:hover,\n.save-btn:focus {\n    background: #d35400 !important;\n    color: #673417 !important;\n}\n\n.purple-btn:hover {\n    color: #fff !important;\n}\n\n.p0 {\n    padding: 0px;\n}\n\n.m0 {\n    margin: 0px;\n}\n\n.mtop0 {\n    margin-top: 0;\n}\n\n.mbtm0 {\n    margin-bottom: 0;\n}\n\n.mbtm8 {\n    margin-bottom: .5rem;\n}\n\n.whitebg {\n    background-color: var(--white);\n}\n\n.fleft {\n    float: left;\n}\n\n.fright {\n    float: right;\n}\n\n.small-thumb-list {\n    width: 120px;\n    height: 68px;\n}\n\n.purple-btn {\n    width: 100%;\n    background-color: var(--baseblue);\n    color: var(--white);\n    border: none;\n    transition: all .5s;\n}\n\n.purple-btn:hover,\n.purple-btn:focus {\n    background-color: var(--baseblue);\n}\n\n.h44 {\n    height: 44px;\n}\n\n.ptop0 {\n    padding-top: 0;\n}\n\n.pright0 {\n    padding-right: 0;\n}\n\n.pbtm0 {\n    padding-bottom: 0;\n}\n\n.pleft0 {\n    padding-left: 0;\n}\n\n.myquestion-bg {\n    background-color: #F2FAFA;\n    color: #039C93 !important;\n    border: 2px solid #D1EAEA !important;\n    /* justify-content: center;\n     */\n    align-items: center;\n}\n\n.question-fixer-box {\n    height: 96px;\n    border: 1px solid #dee2e6;\n}\n\n.alert-infobox {\n    color: #19325c;\n    font-weight: 600;\n    margin-bottom: .5rem;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #ebf3ff;\n    padding: .25rem 1rem .25rem .75rem;\n    /* border: 1px solid #d0e1f9;\n     */\n}\n\n.alert-infobox::before {\n    content: \"\\f05a\";\n    font-family: var(--Awesome);\n    font-size: 1rem;\n    margin-right: .5rem;\n}\n\n.redtxt {\n    color: var(--alerttxt);\n}\n\n.course-videolist-pagination {\n    position: absolute;\n    bottom: -55px;\n    right: 0;\n    padding: 0;\n}\n\n.ans-hint {\n    background-color: #FFF9D7;\n    color: #F76B1C;\n    border: 1px solid #EFE6B0;\n}\n\n.add-option-btn {\n    background: linear-gradient(0deg, #F2F2F2 0%, #EAEAEA 100%), #F2F2F2;\n    font-size: 0.6875rem;\n    color: var(--baseblue);\n    font-weight: var(--fw-600);\n    border-radius: 2px;\n    border: 1px solid #D9D9D9;\n    cursor: pointer;\n}\n\n.add-option-btn:hover {\n    background: #eeeded;\n    color: var(--baseblue);\n    font-weight: var(--fw-600);\n}\n\n.slide-in-container {\n    position: fixed;\n    bottom: 30px;\n    left: 10px;\n    max-width: 25%;\n    transform: translateX(0%);\n    transition: transform 0.4s ease-out;\n    z-index: 1000;\n}\n\n.slide-in-container.visible {\n    transform: translateX(100%);\n}\n\n.goi-logo {\n    position: relative;\n    width: 50%;\n    display: flex;\n    align-items: center;\n}\n\n.goi-logo img {\n    float: left;\n    height: 40px;\n    border-right: 0 solid #fff;\n    padding-right: 0;\n    margin-right: 10px;\n    fill: #fff;\n}\n\n.goi-logo ul {\n    padding: 0;\n    margin: 0;\n}\n\n.goi-logo li {\n    list-style: none;\n    display: inline-block;\n    font-size: 12px;\n    font-weight: 500;\n}\n\n.goi-logo li:first-child {\n    text-align: right;\n}\n\n.goi-logo li:last-child {\n    border-left: 1px solid var(--lightGrey);\n    padding-inline: 1rem;\n    margin-inline: 1rem;\n}\n\n.lms-mascotbg {\n    background-image: url(https://pmfby.amnex.co.in/pmfby/lms/lms-bg.png);\n    /* height: 400px;\n     */\n    min-height: 473px;\n    background-repeat: no-repeat;\n    background-position-y: center;\n}\n\n.lms-registor-mascotbg {\n    background-image: url(https://pmfby.amnex.co.in/pmfby/lms/registration-bg.png);\n    min-height: 607px;\n}\n\n\n.login-bg {\n    padding: 1rem 2rem 2rem 2rem;\n    /* min-height: 461px; */\n    min-height: 396px;\n    margin-top: 1.25rem;\n}\n\n.success-msg {\n    background-color: #9EFFD2;\n    border: 1px solid #8FE2BB;\n    color: #273D0E;\n    font-size: 0.6875rem;\n    font-weight: var(--fw-600);\n    text-align: center;\n}\n\n.question-preview-listing {\n    background-color: var(--whitebg);\n    border-bottom: solid 1px #e9e9e9;\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n    margin-bottom: 1rem;\n}\n\n.question-preview-listing:last-child {\n    border-bottom: 0;\n}\n\n.searchbox-input {\n    height: 40px;\n    vertical-align: middle;\n    padding-top: 0px;\n}\n\n.search-icon {\n    background: #231444;\n}\n\n.search-icon::before {\n    content: \"\\f002\";\n    font-family: var(--Awesome);\n    color: rgba(33, 33, 33, 0.2);\n    position: absolute;\n    right: 1.75rem;\n    top: 1.7rem;\n}\n\n.search-icon2 {\n    border: 1px solid #000;\n    height: 40px;\n    width: 49px;\n    position: absolute;\n    right: 14px;\n    top: 2px;\n    background: #231444;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 4px;\n    z-index: 1;\n    cursor: pointer;\n}\n\n.search-icon2::before {\n    content: \"\\f002\";\n    font-family: var(--Awesome);\n    font-size: 1rem;\n    color: #fff;\n    /* color: rgba(33, 33, 33, 0.2);\n    position: absolute;\n    right: 1.75rem;\n    top: 0.6rem; */\n}\n\n.mypagination-listing .active>.page-link {\n    background-color: #231444;\n    border: 1px solid #231444;\n}\n\n.invalid-feedback::before {\n    content: \"\\f06a\";\n    /* content: \"\\f071\";\n     */\n    font-family: var(--Awesome);\n    color: var(--bs-form-invalid-color);\n    margin-right: .25rem;\n}\n\n.list-selected-badge {\n    display: inline-flex;\n    justify-self: center;\n    align-items: center;\n    background-color: #3e80c7 !important;\n    color: #fff !important;\n    font-size: 10px !important;\n    font-family: var(--fontOpenSans);\n    font-weight: 600;\n    border-radius: 2px;\n    margin-bottom: .25rem;\n}\n\n.card-body {\n    padding-top: .5rem;\n    min-height: 96px;\n}\n\n.progress {\n    background-color: #CCCCCC !important;\n}\n\n.progress .progress-bar {\n    background-color: #231444 !important;\n}\n\n.course-listing,\n.course-listing-learner,\n.publiccourse-listing {\n    font-family: var(--fontOpenSans);\n    min-height: 280px;\n    border: 0;\n    margin-bottom: 1rem;\n    border: 1px solid var(--greyBorder);\n    cursor: pointer;\n}\n\n.course-listing:hover {\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n    position: absolute;\n    z-index: 1;\n    transition: all 0.4s ease-in-out;\n    width: calc(25% - 1rem);\n}\n\n.course-listing-learner:hover {\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n    position: absolute;\n    z-index: 1;\n    transition: all 0.4s ease-in-out;\n    width: calc(33% - 1rem);\n}\n\n.course-listing:hover .course-card-body,\n.course-listing-learner:hover .course-card-body {\n    position: relative\n}\n\n.course-listing:hover .course-thumbnail-hover,\n.course-listing-learner:hover .course-thumbnail-hover {\n    display: none;\n}\n\n.course-listing:hover .course-thumbnail-hover,\n.course-listing-learner:hover .course-thumbnail-hover {\n    align-self: start;\n    background: rgba(0, 0, 0, 0.5);\n    overflow: hidden;\n    position: relative;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    z-index: 10;\n    top: 0;\n    left: 0;\n    display: block;\n}\n\n.course-listing:hover .course-thumbnail-hover::before,\n.course-listing-learner:hover .course-thumbnail-hover::before {\n    height: 208px;\n    font-family: var(--Awesome);\n    content: \"\\f01d\";\n    position: absolute;\n    font-size: 3rem;\n    inset: 0;\n    margin: 0 auto;\n    z-index: 10;\n    color: #FAFAFA;\n    left: 40%;\n    top: 30%;\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n    box-sizing: border-box;\n}\n\n.course-listing:hover .course-thumbnail-hover::after,\n.course-listing-learner:hover .course-thumbnail-hover::after {\n    height: auto;\n    font-family: var(--Awesome);\n    content: \"\";\n    position: absolute;\n    font-size: 3rem;\n    inset: 0;\n    transition: opacity 0.3s ease;\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n    box-sizing: border-box;\n}\n\n\n\n.course-listing h6,\n.publiccourse-listing h6 {\n    font-family: var(--fontOpenSans);\n    font-size: calc(var(--fs10) + 5px);\n    font-weight: var(--fw-600);\n    color: #0F0F0F;\n}\n\n.course-listing h6::first-letter, \n.publiccourse-listing h6::first-letter {\n    text-transform: uppercase;\n}\n\n\n.more-menu-listing {\n    display: flex;\n    flex-direction: column;\n    background-color: #fff;\n    position: absolute;\n    right: 1rem;\n    width: 110px;\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n    padding: .5rem 0;\n    z-index: 10000;\n    border-radius: 4px;\n    bottom: 5px;\n}\n\n.more-menu-listing a {\n    font-size: calc(var(--fs10) + 4px);\n    text-align: left;\n    line-height: 1.5rem;\n    padding-block: .5rem;\n    padding-inline: 1rem;\n    -webkit-user-select: none;\n    /* Safari */\n    -ms-user-select: none;\n    /* IE 10 and IE 11 */\n    user-select: none;\n    /* Standard syntax */\n    cursor: pointer;\n}\n\n.more-menu-listing a:hover,\n.more-menu-listing a:focus {\n    background-color: #EFFFF8;\n}\n\n.course-status {\n    display: inline-block;\n    padding: .25rem .5rem;\n    border: 1px solid;\n    border-radius: 2px;\n    font-size: calc(var(--fs10) - 2px);\n    font-weight: var(--fw-600);\n    letter-spacing: 0.045rem;\n    /* margin-bottom: .5rem; */\n    text-transform: capitalize;\n    min-width: 68px;\n    text-align: center;\n}\n\n.approve {\n    background-color: #cafde5;\n    border-color: #b8f3d7;\n}\n\n.pending {\n    background-color: #fdf2ca;\n    border-color: #fbe8a4;\n}\n\n.reject {\n    background-color: #fdcaca;\n    border-color: #f3adad;\n}\n\n.public {\n    background-color: #6b4ec5;\n    color: #fff;\n    border-color: #a08dd9;\n    white-space: nowrap;\n}\n\n.mandate {\n    background-color: #c54e4e;\n    color: #fff;\n    border-color: #c96a6a;\n    white-space: nowrap;\n}\n\n\n\n.card-text {\n    font-size: calc(var(--fs10) + 2px);\n    font-family: var(--fontOpenSans);\n    font-weight: var(--fw-600);\n    color: rgba(15, 15, 15, .40);\n    text-transform: capitalize;\n}\n\n.green-gradient-bg {\n    position: relative;\n    background-image:\n        /* linear-gradient(180deg, #EFFECE 0%, #EDFEE0 27.45%, #EEFCC7 56.42%, #D0F383 100%), */\n        url(https://pmfby.amnex.co.in/pmfby/lms/green-gradient-bg.png);\n    /* Other background settings */\n    min-height: 200px;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.h304 {\n    /* height: 304px; */\n    height: 200px;\n}\n\n.new-coursebtn {\n    position: absolute;\n    top: 40%;\n    left: 40%;\n    transform: translate(-40%, -40%);\n    padding: 20px;\n    border-radius: 8px;\n}\n\n.new-coursebtn h6 {\n    font-family: var(--fontOpenSans);\n}\n\n.green-grad-btn {\n    font-family: var(--fontOpenSans) !important;\n    position: relative;\n    display: inline-flex;\n    font-size: 0.875rem;\n    min-width: 220px;\n    align-items: center;\n    justify-content: center;\n    background: linear-gradient(180deg, rgb(101, 174, 87) 0%, #D0F382 100%);\n    min-height: 64px;\n    font-family: var(--fontBarlow);\n    font-weight: var(--fw-500);\n    border: 1px solid #baeb9d;\n    border-radius: 16px;\n    color: #1E1E1E;\n    box-sizing: border-box;\n    transition: all 0.4s ease;\n}\n\n.green-grad-btn::before {\n    content: url(/public/img/new-course-icon2.svg);\n    width: 48px;\n    margin-right: .5rem;\n}\n\n.green-grad-btn:hover {\n    color: #1E1E1E;\n    border: 1px solid #baeb9d;\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;\n}\n\n.green-grad-btn:focus {\n    color: #1E1E1E;\n    box-shadow: 0 0 10px 4px rgba(101, 174, 87, 0.7);\n}\n\n.blue-grad-btn {\n    position: relative;\n    font-family: var(--fontOpenSans) !important;\n    font-size: 0.875rem;\n    display: inline-flex;\n    justify-content: center;\n    min-width: 220px;\n    align-items: center;\n    /* background: linear-gradient(180deg, rgb(71, 221, 255) 0%, #DCC3FF 100%); */\n    background: linear-gradient(180deg, rgb(247, 198, 103) 0%, rgb(240, 232, 156) 100%);\n    min-height: 64px;\n    font-family: var(--fontBarlow);\n    font-weight: var(--fw-500);\n    border: 1px solid #F9D88C;\n    border-radius: 16px;\n    color: #1E1E1E;\n    box-sizing: border-box;\n    transition: all 0.4s ease;\n}\n\n.blue-grad-btn::before {\n    content: url(/public/img/approve-course-icon.svg);\n    /* width: 48px; */\n    padding-top: .45rem;\n    margin-right: .5rem;\n}\n\n.blue-grad-btn:hover {\n    color: #1E1E1E;\n    border: 1px solid #F9D88C;\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;\n}\n\n.blue-grad-btn:focus {\n    color: #1E1E1E;\n    box-shadow: 0 0 10px 4px rgba(71, 221, 255, 0.7);\n}\n\n.purple-grad-btn {\n    position: relative;\n    font-family: var(--fontOpenSans) !important;\n    font-size: 0.875rem;\n    display: inline-flex;\n    justify-content: center;\n    min-width: 220px;\n    align-items: center;\n    /* background: linear-gradient(180deg, rgb(148, 71, 255) 0%, #FFC3EB 100%); */\n    background: linear-gradient(180deg, rgb(214, 164, 203) 0%, rgb(243, 232, 243) 100%);\n    min-height: 64px;\n    font-family: var(--fontBarlow);\n    font-weight: var(--fw-500);\n    border: 1px solid #F9D0F1;\n    border-radius: 16px;\n    color: #1E1E1E;\n    box-sizing: border-box;\n    transition: all 0.4s ease;\n}\n\n.purple-grad-btn::before {\n    content: url(/public/img/assign-course-icon.svg);\n    /* width: 48px; */\n    padding-top: .5rem;\n    margin-right: .5rem;\n}\n\n.purple-grad-btn:hover {\n    color: #1E1E1E;\n    border: 1px solid #F9D0F1;\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;\n}\n\n.purple-grad-btn:focus {\n    color: #1E1E1E;\n    box-shadow: 0 0 10px 4px rgba(148, 71, 255, 0.7);\n}\n\n\ninput[type=\"search\"] {\n    min-height: 44px;\n    box-sizing: border-box;\n    padding: 0 0 0 8px;\n    margin: 0;\n}\n\n.existing-courselist h6 {\n    margin-bottom: 0;\n    font-size: calc(var(--fs10) + 6px);\n    /* font-size: 1.25rem; */\n    font-weight: 600;\n    padding-top: .5rem;\n}\n\n.btn-close {\n    font-size: var(--fs10);\n    position: relative;\n    right: 10px;\n    background-color: #edeaea;\n    width: 1em;\n    border-radius: 100%;\n    height: 1em;\n}\n\n.form-check-input:checked[name=loginMethod],\n.form-check-input:checked[type=checkbox] {\n    background-color: #231444;\n    border-color: #231444;\n}\n\n.subhead-txt {\n    color: var(--lightsubheading);\n}\n\n.video-title-container {\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n}\n\n.status-badge {\n    font-size: 0.7rem;\n    padding: 0.4em 0.6em;\n    border: solid 1px #000;\n    border-radius: 20px;\n    display: inline-block;\n    width: 90px;\n    text-align: center;\n}\n\n.badge-success {\n    border-color: green;\n    color: green;\n}\n\n.badge-danger {\n    border-color: red;\n    color: red;\n}\n\n.btn-outline-dark {\n    border-radius: 10px;\n    padding: 0.4em 1em;\n    font-size: 0.8rem;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    gap: 4px;\n}\n\n.btn-filled-dark,\n.btn-filled-dark:hover,\n.btn-filled-dark:active {\n    color: #fff !important;\n    background-color: #231444 !important;\n    border-color: #231444 !important;\n    border-radius: 4px;\n    padding: 0.75em 1.5em;\n    font-size: 0.8rem;\n    font-weight: 600;\n    display: inline-flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1rem;\n}\n\ninput[type=\"checkbox\"] {\n    transform: scale(1.2);\n}\n\n.video-listing-bg {\n    position: relative;\n    background-color: #EFFFF8;\n    padding: 1rem;\n    height: 400px;\n    border: 1px solid #D9FFEE;\n}\n\n\n\n.upload-btn {\n    min-width: 90px;\n    border: 1px solid #ddd !important;\n    color: #333 !important;\n    background: #fff !important;\n}\n\n\n.course-thumbnail {\n    height: 208px;\n    position: relative;\n    display: inline-block;\n    width: 100%;\n    padding-top: calc(6 / 9 * 100%);\n    overflow: hidden;\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n    cursor: pointer;\n    box-sizing: border-box;\n}\n\n\n\n\n.course-thumbnail img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: fill;\n}\n\n.notificationbell i {\n    text-decoration: none;\n    background: linear-gradient(289deg, rgba(247, 107, 28, 1) 0%, rgba(252, 224, 22, 1) 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n\n.notificationbell:hover {\n    background-color: #f8f9fa;\n}\n\n\n.notification-count sup {\n    background-color: #E83B2D;\n    display: inline-flex;\n    width: 12px;\n    height: 12px;\n    position: relative;\n    top: -10px;\n    font-size: 9px;\n    color: #fff;\n    justify-content: center;\n    align-items: center;\n    padding: 8px;\n    border-radius: 40px;\n}\n\n.usermenu-ddl:hover,\n.usermenu-ddl:focus,\n.usermenu-ddl:active {\n    background-color: #f8f9fa;\n\n}\n\n.usermenu-ddl .btn.show,\n.usermenu-ddl .btn:first-child:active {\n    background-color: #f8f9fa;\n}\n\n.min-h100 {\n    min-height: 85vh;\n}\n\na {\n    text-decoration: none;\n    transition: all .5s;\n}\n\na:hover {\n    /* text-decoration: underline; */\n    color: #3e68ff;\n}\n\n.course-preview-listing {\n    position: sticky;\n    top: 10px;\n    background-color: #EFFFF8;\n    padding: 0;\n    border: 2px solid #D9FFEE;\n    /* min-height: 640px; */\n    overflow-x: hidden;\n    max-height: 560px;\n    overflow-y: auto;\n    text-transform: capitalize;\n    box-sizing: border-box;\n}\n\n.course-preview-listing h5 {\n    /* padding-bottom: .5rem; */\n    text-transform: math-auto;\n}\n\n\n/* ----------Scrollbar CSS START Here----------- */\n.course-preview-listing::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n}\n\n.course-preview-listing::-webkit-scrollbar-track {\n    background: #d6d6d6;\n    /* track (background) color */\n    border-radius: 10px;\n}\n\n.course-preview-listing::-webkit-scrollbar-thumb {\n    background: radial-gradient(circle, rgba(238, 174, 202, 1) 0%, rgba(148, 187, 233, 1) 100%);\n    /* scrollbar handle color */\n    border-radius: 10px;\n    height: 12px;\n}\n\n/* ----------Scrollbar CSS END Here----------- */\n\n\n/* .course-preview-listing > div:first-of-type {\n    background-color: #DEEAFF;\n} */\n\n.course-lessons,\n.disable-lessonlist {\n    display: flex;\n    gap: .5rem;\n    cursor: pointer;\n    text-decoration: none;\n    border-bottom: 1px solid #D9FFEE;\n    padding-bottom: .25rem;\n    margin-bottom: .5rem;\n    padding: .5rem .5rem .5rem 1rem;\n}\n\n.disable-lessonlist {\n    cursor: not-allowed;\n    color: #9A9A9A;\n}\n\n.course-lessons:hover {\n    background-color: #a0f6ff;\n}\n\n.disable-lessonlist:hover {\n    background-color: transparent;\n}\n\n.course-lessons.active {\n    background-color: #a0f6ff;\n    border-bottom: 2px solid #231444;\n    padding: .5rem .5rem .5rem 1rem;\n    margin-bottom: .25rem;\n    /* background-color:#DEEAFF; */\n    background-color: #a0f6ff;\n    padding: .75rem;\n    /* padding-inline: .5rem; */\n    /* width: 98%; */\n    margin: 0 auto;\n}\n\n.course-lessons span:nth-child(2),\n.disable-lessonlist span:nth-child(2) {\n    font-size: 13px;\n    color: #333;\n    padding-top: 2px;\n}\n\n.duration-txt {\n    display: flex;\n    gap: 56px;\n    align-items: center;\n    justify-content: space-between;\n    color: #9A9A9A;\n    font-size: 0.725rem;\n    margin-block: .25rem;\n    white-space: nowrap;\n}\n\n.listed-videos {\n    height: 230px;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    padding-top: .5rem;\n}\n\n.listed-assessment {\n    display: flex;\n    justify-content: center;\n    max-width: 28px;\n    max-height: 28px;\n    align-items: center;\n    background-color: #d8e4f5;\n    border-radius: 4px;\n\n}\n\n.listed-videos-checkbox {\n    width: 28px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 28px;\n    background-color: #d8e4f5;\n    border-radius: 4px;\n    margin-top: .25rem;\n}\n\n.courselist-toggle {\n    position: absolute;\n    top: 4%;\n    right: 5%;\n}\n\n.course-video-view {\n    background-color: #16161D;\n    padding: 1rem;\n    border-radius: 1%;\n    max-height: 490px;\n}\n\n.course-overview-wrapper {\n    margin-block: 1rem;\n}\n\n.course-overview-wrapper>h4:first-of-type {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    font-size: .8rem;\n    font-family: var(--fontOpenSans);\n    border-bottom: 1px solid #dee2e6;\n    /* padding-block: .5rem; */\n    /* margin-bottom: 1rem; */\n}\n\n.course-overview-wrapper>h4 span:nth-child(1) {\n    background-color: #beffd8;\n    color: #212529;\n    font-weight: var(--fw-600);\n    border: 1px solid #ecebeb;\n    padding: 1rem;\n    min-width: 200px;\n}\n\n.course-overview-wrapper>h4 span:nth-child(2),\n.course-overview-wrapper>h4 span:nth-child(3) {\n    background-color: transparent;\n    border: none;\n}\n\n.nocourse-addedbox {\n    text-align: center;\n    border: 1px dashed #a9c2e7;\n    padding: .5rem;\n    background-color: #ffffff;\n    font-size: 12px;\n    /* font-weight: 600; */\n    letter-spacing: 0.021rem;\n    line-height: 1.0rem;\n    color: #636972;\n}\n\n.v-line {\n    position: relative;\n}\n\n.v-line::before {\n    content: '';\n    border: .5px solid #efefef;\n    position: absolute;\n    z-index: 0;\n    height: 100%;\n}\n\n.remove-videosbtn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-left: 8px;\n    border-radius: 100%;\n    width: 24px;\n    height: 24px;\n}\n\n.dropdown-menu {\n    min-width: 220px;\n}\n\n.courses-viewbg {\n    background-color: #fff;\n    /* background-color: #F2F8F2; */\n    /* margin-top: .5rem; */\n}\n\n.courses-tabcontainer {\n    border-bottom: 1px solid #D9D9D9;\n    margin-top: .25rem;\n    justify-content: center;\n    gap: 1rem;\n}\n\n.courses-tabcontainer li:first-child {\n    display: none;\n}\n\n.courses-tabcontainer .nav-link.active {\n    font-weight: 900;\n    color: #231444;\n    border-top: 0;\n    border-right: 0;\n    border-bottom: 4px solid #231444;\n    border-left: 0;\n}\n\n.courses-tabcontainer .nav-link {\n    color: #231444;\n    font-size: 1rem;\n    justify-content: center;\n    align-items: center;\n    display: inline-flex;\n    gap: 6px;\n}\n\n.courses-tabcontainer .nav-link:hover {\n    border-color: transparent;\n}\n\n.courses-tabcontainer .nav-item {\n    flex-grow: 0;\n    width: auto;\n    white-space: nowrap;\n}\n\n.courses-tabcontainer * .nav-tabs .nav-link:hover {\n    border: 0 !important;\n}\n\n.course-infohead-section {\n    background-color: #e1f7db;\n    padding: .5rem 1rem;\n    /* margin-left: .10rem; */\n    /* width: 98.25%; */\n    box-sizing: border-box;\n}\n\n.h100percent {\n    height: 100%;\n}\n\n.course-status-card {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    font-family: var(--fontBarlow);\n    z-index: 1;\n    padding: 0;\n}\n\n.course-status-card p {\n    font-size: 0.875rem !important;\n}\n\n.middle-section {\n    /* background-color:var(--whitebg); */\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n}\n\n.slide-show {\n    /* background-image: url(../public/img/slider-1.jpg); */\n    /* height: 202px; */\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n\n.learners-tabsinfo {\n    background: #2A7B9B;\n    background: linear-gradient(180deg, rgba(223, 255, 240, 1) 0%, rgba(245, 245, 245, 1) 100%);\n    /* padding-block: .5rem; */\n    border: 0;\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n    display: flex;\n    justify-content: center;\n    gap: 10rem;\n    font-size: .85rem;\n\n}\n\n.learners-tabsinfo * .nav-link {\n    color: #231444;\n    padding-block: 1rem;\n    padding-inline: 2rem;\n    box-sizing: border-box;\n    border: 0;\n    transition: all .5s;\n}\n\n.learners-tabsinfo * .nav-link:hover,\n.learners-tabsinfo * .nav-link:focus {\n    border: 0;\n    border-color: transparent;\n}\n\n.learners-tabsinfo * .nav-link.active {\n    background-color: #231444;\n    color: #fff;\n    font-weight: var(--fw-700);\n    border: 0;\n    box-sizing: border-box;\n    padding-block: 1rem;\n    padding-inline: 2rem;\n    border-color: transparent;\n}\n\n.learner-rightside-widgetbox {\n    min-height: 320px;\n    /* height: 100vh; */\n    border: 2px solid;\n    border-image: linear-gradient(180deg, rgba(222, 255, 255, 1) 0%, rgba(245, 245, 245, 1) 100%);\n    border-image-slice: 1;\n    border-radius: 1.5rem;\n    margin-bottom: 1rem;\n    box-sizing: border-box;\n    padding: .5rem;\n}\n\n.learner-rightside-widgetbox h6 {\n    font-size: 1.20rem;\n    background: linear-gradient(180deg, #FCE016, #F76B1C);\n    /* your gradient */\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n\n    /* Optional for better compatibility */\n    background-clip: text;\n    color: transparent;\n}\n\n.certificate-infobox {\n    margin-block: 1rem;\n}\n\n.certificate-infobox h5 {\n    font-family: var(--fontOpenSans);\n    font-size: 0.75rem;\n}\n\n.certificate-infobox span {\n    font-size: 0.625rem;\n    color: rgba(15, 15, 15, .40);\n}\n\n.my-innermenu {\n    gap: 1rem;\n}\n\n.my-innermenu .dropdown {\n    min-height: 40px;\n}\n\n.my-innermenu .dropdown:hover {\n    background-color: #f8f9fa;\n}\n\n.my-innermenu * .btn-light {\n    background-color: transparent;\n}\n\n.question-list-container {\n    height: 70vh;\n    padding: 1rem;\n    padding-inline: 1rem !important;\n    background-color: #fff;\n    overflow-y: scroll;\n}\n\n.question-list-container h4 {\n    font-size: 1.3rem;\n    font-weight: var(--fw-600);\n}\n\n.question-list-container h4::before {\n    content: \"Quiz Title :- \";\n}\n\n\n/* ----------Scrollbar CSS START Here----------- */\n.question-list-container::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n}\n\n.question-list-container::-webkit-scrollbar-track {\n    background: #d6d6d6;\n    /* track (background) color */\n    border-radius: 10px;\n}\n\n.question-list-container::-webkit-scrollbar-thumb {\n    background: linear-gradient(rgba(253, 29, 29, 1) 50%, rgba(252, 176, 69, 1) 100%);\n    /* scrollbar handle color */\n    border-radius: 10px;\n    height: 12px;\n}\n\n/* ----------Scrollbar CSS END Here----------- */\n\n.quiz-box {\n    /* box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; */\n    border: 0 !important;\n}\n\n.quiz-box .card-body {\n    background-color: #F5FEF9;\n    border: 1px solid #dcefe6;\n    border-radius: 12px;\n    font-size: 13px;\n    /* padding: 1.5rem; */\n    padding-block: 1rem;\n    padding-left: 1rem;\n    padding-right: 2rem;\n    max-height: initial;\n}\n\n.quiz-box .list-group-item {\n    background-color: transparent;\n    margin-top: .5rem;\n}\n\n.quiz-box .list-group-item .row {\n    align-items: center;\n}\n\n.quiz-box .list-group-item .col-md-1 {\n    justify-content: center;\n    display: flex;\n}\n\n.quiz-box .list-group-item .col-md-1 .form-check {\n    display: flex;\n    gap: .5rem;\n}\n\n.quiz-box .list-group-item .col-md-11 {\n    background-color: #fff;\n    font-weight: 500;\n    border: 1px solid #DEE2E1;\n    border-radius: 8px;\n    padding-block: .5rem;\n\n}\n\n.middle-content {\n    background-color: #fff;\n    min-height: calc(100vh - 175px);\n    padding-block: 1rem;\n    box-sizing: border-box;\n    font-family: var(--fontOpenSans);\n    box-shadow: 0 12px 16px 2px rgba(0, 0, 0, .1);\n    padding-inline: 2rem;\n}\n\n.middle-content h4 {\n    font-size: calc(var(--fs10) + 10px);\n}\n\n.middle-content p {\n    text-align: justify;\n    font-size: .85rem;\n    padding-top: 10px;\n    line-height: 1.5rem;\n}\n\n.page-heading {\n    border-bottom: 1px solid #b8e986;\n    padding-bottom: 1rem;\n}\n\n.inner-bg {\n    background-image: url(https://pmfby.amnex.co.in/pmfby/lms/inner-pages-bg.jpg);\n}\n\n.assign-course-list,\n.already-assigned-courselist {\n    position: relative;\n    padding: .5rem;\n    width: 98%;\n    margin: 0 auto;\n}\n\n.assign-course-list h5,\n.already-assigned-courselist h5 {\n    margin-bottom: .5rem;\n}\n\n.assign-course-list img,\n.already-assigned-courselist img {\n    width: 120px;\n    height: 84px;\n    border-radius: 4px;\n}\n\n.added-badge,\n.newly-added-badge {\n    position: absolute;\n    color: #fff;\n    font-size: 10px;\n    font-weight: 500;\n    right: 0;\n    width: 64px;\n    text-align: center;\n    padding-block: .25rem;\n\n}\n\n.added-badge {\n    background: #2A7B9B;\n    background-image: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    top: 0px;\n}\n\n.newly-added-badge {\n    background: #833AB4;\n    background-image: linear-gradient(to right, #fa709a 0%, #fee140 100%);\n    top: 0;\n    z-index: 20;\n}\n\n\n.add-arrow-btn,\n.unassign-arrowbtn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #ffffff;\n    border-radius: 4px;\n    cursor: pointer;\n    text-align: center;\n    transition-duration: 0.4s;\n    text-decoration: none;\n    overflow: hidden;\n}\n\n.add-arrow-btn {\n    background-color: #1D660F;\n}\n\n.unassign-arrowbtn {\n    background-color: #f16557;\n\n}\n\n\n.course-count {\n    color: #3673a7;\n}\n\n.new-course-count {\n    color: #fd9620;\n}\n\n.course-Document {\n    cursor: pointer;\n    text-decoration: none;\n    border-bottom: 1px solid #D9FFEE;\n    padding: .5rem .5rem .5rem 0.5rem;\n    font-weight: bold;\n}\n\n.course-Document:hover {\n    background-color: #a0f6ff;\n}\n\n/* ----------Scrollbar CSS START Here----------- */\n.listing-newscroll::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n}\n\n.listing-newscroll::-webkit-scrollbar-track {\n    background: #D9D9D9;\n    /* track (background) color */\n    border-radius: 10px;\n}\n\n.listing-newscroll::-webkit-scrollbar-thumb {\n    background: radial-gradient(circle, rgba(238, 174, 202, 1) 0%, rgba(148, 187, 233, 1) 100%);\n    /* scrollbar handle color */\n    border-radius: 10px;\n    height: 12px;\n}\n\n/* ----------Scrollbar CSS END Here----------- */\n\n\n\n\n/* ----------Landing Page CSS START Here----------- */\n\n.top-navbar {\n    background: linear-gradient(90deg, #65AE57 0%, #2A4824 100%);\n}\n\n.top-navbar.navbar {\n    min-height: 44px;\n    padding-top: .15rem;\n    padding-bottom: .15rem;\n}\n\n.top-navbar .container-fluid {\n    min-height: 38px;\n}\n\n.top-navbar .nav-link {\n    color: #fff;\n    display: flex;\n    justify-content: left;\n    gap: 8px;\n    align-items: center;\n    font-size: .86rem;\n    line-height: 1.15;\n    padding-top: .25rem;\n    padding-bottom: .25rem;\n    transition: all .5s;\n}\n\n.top-navbar .nav-link:hover,\n.top-navbar .nav-link * i:hover {\n    background: linear-gradient(0deg, #F0E89C 0%, #F7C667 100%);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n\n.top-navbar .nav-link.active {\n    color: #fff;\n\n}\n\n.top-navbar .dropdown-menu {\n    color: #010101;\n}\n\n.hero-slider {\n    position: relative;\n    background-color: #f9f9f9;\n    /* border-bottom: 1px solid #D1F385; */\n}\n\n.hero-slider-img {\n    height: 300px;\n}\n\n.slider {\n    height: 300px;\n    overflow: hidden;\n}\n\n.slider img {\n    width: 100%;\n    height: 300px;\n    object-fit: cover;\n    object-position: center;\n}\n\n.count-stats {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 96%;\n    height: auto;\n    flex-shrink: 0;\n    border-radius: 28px;\n    padding: .65rem 1rem .8rem;\n    border: 1px solid #F3FFD8;\n    margin: 0 auto;\n    background: linear-gradient(90deg, #8CFF23 0%, #CDFE78 32.52%, #D7FC9C 58.8%, #AFFC9C 100%);\n}\n\n.count-list {\n    display: inline-flex;\n    align-items: center;\n    gap: 5rem;\n    color: #231444;\n    justify-content: space-evenly;\n    padding: 0;\n    margin: 0;\n}\n\n.count-list li {\n    display: flex;\n    align-items: center;\n    justify-self: center;\n    font-size: .78rem;\n    line-height: 1.2;\n    width: 148px;\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n}\n\n.count-list li .icon {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #231444;\n    width: 3rem;\n    height: 3rem;\n    border-radius: 40px;\n}\n\n.count-list li .icon svg {\n    max-width: 1.35rem;\n    max-height: 1.35rem;\n}\n\n.count-list li .count {\n    font-family: var(--fontBarlow);\n    font-weight: 800;\n    font-size: 1.45rem;\n    line-height: 1.05;\n    margin-top: .15rem;\n}\n\n.count-list li span:nth-child(2) {\n    display: flex;\n    flex-direction: column;\n}\n\n.about-lms {\n    position: relative;\n    z-index: 0;\n    /* margin-top: 5rem; */\n    padding-block: 2rem;\n    color: #47444E;\n}\n\n.about-imgbox {\n    text-align: center;\n}\n\n.about-lms-grid {\n    align-items: flex-start;\n}\n\n.about-lms-main {\n    padding-right: 1.25rem;\n}\n\n.about-lms-main .about-imgbox img {\n    max-width: 240px;\n    width: 100%;\n}\n\n.about-events-panel {\n    padding-left: 1.25rem;\n    border-left: 1px solid #edf0ee;\n}\n\n.about-lms p,\n.course-container p {\n    line-height: 1.6rem;\n}\n\n.course-container ul {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6rem;\n}\n\n.hightligh-link {\n    background: linear-gradient(0deg, #F0E89C 0%, #F7C667 100%);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    font-weight: 800;\n    font-size: calc(var(--fs10) + 6px);\n    transition: all .5s;\n}\n\n\n.card-scrolling {\n    background-color: #fff;\n    /* padding: 1rem; */\n    border: 2px solid #EFEFEF;\n    border-radius: .75rem;\n}\n\n\n.primary-linktxt,\n.secondary-linktxt {\n    text-decoration: underline;\n    transition: all .5s;\n}\n\n.primary-linktxt {\n    color: #F76B1C;\n}\n\n.secondary-linktxt {\n    color: #231444;\n}\n\n\n.mandatory-marked {\n    display: inline-block;\n    background-color: #FFDCC8;\n    color: #F76B1C !important;\n    padding: .5rem;\n    border-radius: 100px;\n    text-decoration: none !important;\n    text-align: center;\n    white-space: nowrap;\n    min-width: 96px;\n}\n\n.mandatory-marked:hover,\n.public-marked:hover {\n    text-decoration: none;\n    color: inherit;\n}\n\n\n.public-marked {\n    display: inline-block;\n    background-color: #E9DFFF;\n    color: #231444 !important;\n    padding: .5rem;\n    border-radius: 100px;\n    text-decoration: none !important;\n    text-align: center;\n    white-space: nowrap;\n    min-width: 96px;\n}\n\n.main-container {\n    min-height: calc(100vh - 130px);\n    /* 60px header + 70px footer */\n}\n\n.start-info,\n.last-view-info {\n    font-size: 11px;\n    line-height: 16px;\n}\n\n\n.hamburger {\n    display: none;\n    font-size: 12px;\n    background: #db8516;\n    color: #fff;\n    border: none;\n    padding: 8px 12px;\n    border-radius: 6px;\n    cursor: pointer;\n    position: relative;\n    z-index: 1001;\n}\n\n#courselist {\n    display: block;\n}\n\n\n/* Course Tracking Module CSS START Here*/\n.count-card-bg {\n    background-color: #EFFFF8;\n    padding-block: 1rem;\n    vertical-align: middle;\n    margin-bottom: 2rem;\n}\n\n.count-card-icon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 3rem;\n    height: 3rem;\n    border-radius: 40px;\n}\n\n.total-icon {\n    background-color: #9B7BE2;\n}\n\n.complete-icon {\n    background-color: #7EBF58;\n}\n\n.inprocess-icon {\n    background-color: #B2983A;\n}\n\n.pending-icon {\n    background-color: #E95A5C;\n}\n\n.count-card-container {\n    background-color: #fff;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border: 2px solid;\n    border-radius: 1rem;\n    padding: .5rem;\n    box-shadow: 0 10px 27px -5px rgb(50 50 93 / 15%), 0 8px 8px -8px rgb(0 0 0 / 13%) !important;\n}\n\n\n.total {\n    border-color: #9B7BE2;\n}\n\n.complete {\n    border-color: #A2E57B;\n}\n\n.inprocess {\n    border-color: #FAD961;\n}\n\n.pending {\n    border-color: #E95A5C;\n}\n\n\n.count-card-container .count-no {\n    font-family: var(--fontBarlow);\n    font-size: 1.5rem;\n    font-weight: var(--fw-700);\n}\n\n.summary-container {\n    line-height: 32px;\n    vertical-align: middle;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    color: rgba(30, 30, 30, 0.9);\n}\n\n\n.summary-txt {\n    display: block;\n    font-size: 2.5rem;\n    font-weight: var(--fw-700);\n}\n\n.approve-course-heading {\n    margin-bottom: 3rem;\n}\n\n.approve-course-container {\n    height: 150px;\n    margin-bottom: 100px;\n}\n\n\n/* Course Tracking Module CSS END Here*/\n\n\n/* ----------Landing Page CSS END Here----------- */\n.hide-menu,\n.show-menu {\n    position: absolute;\n    background-color: #424e78;\n    /* width: 72px; */\n\n    cursor: pointer;\n    /* border: 1px solid #000; */\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    padding-block: 0.25rem;\n    /* top: 4px; */\n    box-sizing: border-box;\n    /* border-top-left-radius: 100px;\n    border-bottom-left-radius: 100px; */\n    color: #fff;\n    flex: 0 0 auto;\n    /* width: 6%; */\n    width: 2%;\n    z-index: 100;\n    box-shadow: rgba(100, 100, 111, 0.5) 0px 7px 29px 0px;\n    transition: all .05s;\n}\n\n.hide-menu {\n    left: 16.6%;\n}\n\n.show-menu {\n    left: 1px;\n}\n\n.left-menu-links {\n    display: flex;\n    gap: 8px;\n    justify-content: flex-start;\n    align-items: center;\n    color: rgb(35, 20, 68);\n    white-space: nowrap;\n    padding-block: 0.5rem;\n    margin-top: 0.5rem;\n}\n\n.left-menu-hd {\n    font-weight: 700;\n    color: rgb(35, 20, 68);\n    padding-top: 1rem;\n    padding-left: 1rem;\n    font-size: 0.875rem !important;\n}\n\n\n.form-check {\n    display: inline-flex;\n    gap: 0.65rem;\n}\n\n.form-check-input:checked {\n    transform: scale(1.3);\n    /* 1.2–1.5 is ideal */\n}\n\n\n.left-menu-panel {\n    min-height: 100vh;\n    border: 1px solid #cccccc;\n    padding: 0;\n    position: relative;\n}\n\n.left-menu-panel * .active {\n    background-color: #2D9152;\n    color: #ffffff;\n}\n\n.btn-inline-border {\n    /* border-right: 1px solid #dee2e6; */\n    border-left: 1px solid #dee2e6;\n    color: #0d6efd;\n}\n\n.pagination {\n    justify-content: end;\n}\n\n.pagination .page-item {\n    margin-left: .25rem;\n    border: 1px solid #dee2e6;\n    margin: 0px;\n}\n\n.pagination .page-item .btn {\n    color: #231444;\n    font-size: .875rem;\n    padding: .5rem .75rem;\n    border-radius: 0px;\n}\n\n/* Blink Circle Online Users START Here */\n\n.online-user {\n    font-family: var(--fontOpenSans) !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    font-size: 12px;\n    border: 1px solid #9df3cb;\n    border-radius: 100px;\n    padding: 5px 8px;\n    background-color: #d0ffe9;\n    margin: 0px !important;\n}\n\n.online-txt {\n    display: inline-flex;\n    justify-content: space-around;\n    align-items: end;\n    gap: 4px;\n    color: #616161;\n}\n\n.activeuser-count {\n    font-weight: 600;\n    font-size: 14px;\n    color: #00350E;\n}\n\n.online-user .circle,\n.online-user .circle::before {\n    content: \" \";\n    margin: 15px;\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    margin: 0 auto;\n    transition: all 0.1s;\n    background-color: #00FF00;\n}\n\n.circle::before {\n    animation: mymove 2s infinite;\n    position: absolute;\n    background-color: #00350E\n}\n\n@-webkit-keyframes mymove {\n    50% {\n        transform: scale(2.5);\n        opacity: 0\n    }\n\n    100% {\n        transform: scale(2.5);\n        opacity: 0\n    }\n}\n\n\n.blinker-homepge,\n.blinker-homepge::before {\n    position: absolute;\n    right: 10px;\n    top: 15px;\n    content: \" \";\n    margin: 15px;\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    margin: 0 auto;\n    transition: all 0.1s;\n    background-color: #00FF00;\n}\n\n.blinker-homepge::before {\n    animation: mymove2 2s infinite;\n    position: absolute;\n    background-color: #b6fbc8;\n    right: 0px;\n    top: 0px;\n\n}\n\n@-webkit-keyframes mymove2 {\n    50% {\n        transform: scale(2.5);\n        opacity: 0\n    }\n\n    100% {\n        transform: scale(2.5);\n        opacity: 0\n    }\n}\n\n/* Blink Circle Online Users END Here */\n\n.mobile-links {\n    display: none;\n}\n\n\n/* Hide Seek Bar and Time Display in Video Controls */\n.hide-seek-bar::-webkit-media-controls-timeline {\n    display: none !important;\n}\n\n.hide-seek-bar::-webkit-media-controls-seek-back-button,\n.hide-seek-bar::-webkit-media-controls-seek-forward-button {\n    display: none !important;\n}\n\n/* .hide-seek-bar::-webkit-media-controls-current-time-display,\n.hide-seek-bar::-webkit-media-controls-time-remaining-display {\n  display: none !important;\n} */\n\n\n.footer-bottom-link {\n    display: flex;\n    justify-content: center;\n    margin-block: .5rem;\n    align-items: center;\n    gap: 1rem;\n\n}\n\n.footer-bottom-link small:nth-child(1) {\n    line-height: 14px;\n    border-right: 1px solid #fff;\n    padding-right: 1rem;\n}\n\n.footer-bottom-link small:nth-child(2) {\n    display: flex;\n    gap: 8px;\n    justify-content: center;\n}\n\n.report-card-container {\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.report-graph-container {\n    background-color: #fff;\n    padding: 1rem;\n    height: 430px;\n}\n\n.report-graph-container canvas {\n    margin: 0 auto;\n    width: 100% !important;\n    height: 100% !important;\n}\n\n/* swiper custom class start */\n\n.custom-swiper {\n    position: relative;\n    /* padding-bottom: 40px; */\n}\n.custom-swiper .swiper {\n    padding-bottom: 20px;\n}\n.custom-swiper .swiper .swiper-pagination-bullets{\n    bottom: 0;\n}\n.custom-swiper .swiper-pagination {\n    position: absolute;\n    bottom: 0 ;\n    left: 0;\n    width: 100%;\n    text-align: center;\n}\n\n.custom-swiper .swiper-pagination-bullet {\n    background: none;\n    border: solid 2px #34A853;\n    opacity: 1;\n    width: 16px;\n    height: 16px;\n}\n\n.custom-swiper .swiper-pagination-bullet-active {\n    background: #34A853;\n}\n\n.custom-swiper .swiper-button-prev,\n.custom-swiper .swiper-button-next {\n    background-color: #3f8d42;\n    border-radius: 4px;\n    padding: 10px;\n    border:none;\n    color: #fff;\n    top: 42% !important;\n    transform: translateY(-42%);\n    margin-top: 0!important;\n    min-height: 55px;\n}\n.custom-swiper .swiper-button-prev{\n    left: 0.3rem;\n}\n.custom-swiper .swiper-button-next {\n    right: 0.3rem !important;\n    \n}\n\n/* swiper custom class end */\n\n/* Profile page */\n.profile-page {\n    background: #f8faf7;\n    min-height: calc(100vh - 72px);\n    padding: 1.5rem;\n}\n\n.profile-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    max-width: 1320px;\n    margin: 0 auto 1rem;\n}\n\n.profile-header h4 {\n    margin: 0;\n    color: #111827;\n    font-family: var(--fontOpenSans);\n    font-size: 1.4rem;\n    font-weight: 800;\n}\n\n.profile-header p,\n.profile-panel-title span {\n    color: #667085;\n    font-size: .88rem;\n    font-weight: 600;\n    margin: .25rem 0 0;\n}\n\n.profile-page > .row {\n    max-width: 1320px;\n    margin-left: auto;\n    margin-right: auto;\n    align-items: stretch;\n}\n\n.profile-page > .row > [class*=\"col-\"] {\n    display: flex;\n    align-self: stretch;\n}\n\n.profile-panel {\n    background: #fff;\n    border: 1px solid #dde6df;\n    border-radius: 8px;\n    box-shadow: 0 4px 14px rgba(17, 24, 39, 0.06);\n    padding: 1rem 1.05rem;\n    margin-bottom: 1rem;\n    width: 100%;\n    height: calc(100%);\n    min-height: 430px;\n    display: flex;\n    flex-direction: column;\n}\n\n.profile-panel-title {\n    border-bottom: 1px solid #edf0ee;\n    margin: 0 -1.05rem .85rem;\n    padding: 0 1.05rem .7rem;\n}\n\n.profile-panel-title h5 {\n    color: #182033;\n    font-size: 1rem;\n    font-weight: 800;\n    margin: 0;\n}\n\n.profile-panel .label {\n    color: #2f3a4a;\n    font-weight: 700;\n}\n\n.profile-panel .form-control,\n.profile-panel .form-select {\n    min-height: 38px;\n    border-color: #d7dfda;\n    color: #1f2937;\n    font-weight: 600;\n}\n\n.profile-panel .form-control[readonly] {\n    background: #f6f8f7;\n    color: #5f6b7a;\n}\n\n.profile-loading {\n    max-width: 1320px;\n    margin: 0 auto;\n    padding: 1rem;\n    border: 1px solid #dde6df;\n    border-radius: 8px;\n    background: #fff;\n    color: #475467;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    gap: .5rem;\n}\n\n.profile-overview {\n    max-width: 1320px;\n    margin: 0 auto 1rem;\n    display: grid;\n    grid-template-columns: auto minmax(0, 1fr) minmax(240px, 320px);\n    align-items: center;\n    gap: 1rem;\n    padding: 1rem;\n    border: 1px solid #dfe8e1;\n    border-radius: 8px;\n    background: linear-gradient(180deg, #ffffff 0%, #f8fbf8 100%);\n    box-shadow: 0 8px 22px rgba(17, 24, 39, 0.07);\n}\n\n.profile-avatar {\n    width: 76px;\n    height: 76px;\n    border-radius: 50%;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 auto;\n    background: linear-gradient(135deg, #2d9152 0%, #83c56b 100%);\n    color: #fff;\n    font-family: var(--fontBarlow);\n    font-size: 1.65rem;\n    font-weight: 800;\n    box-shadow: inset 0 0 0 4px rgba(255, 255, 255, 0.32);\n}\n\n.profile-overview-main {\n    min-width: 0;\n}\n\n.profile-overview-title h5 {\n    color: #111827;\n    font-family: var(--fontOpenSans);\n    font-size: 1.18rem;\n    font-weight: 800;\n    line-height: 1.3;\n    margin: 0;\n}\n\n.profile-overview-title span {\n    display: block;\n    color: #64748b;\n    font-size: .86rem;\n    font-weight: 600;\n    margin-top: .2rem;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.profile-meta-list {\n    display: flex;\n    flex-wrap: wrap;\n    gap: .5rem;\n    margin-top: .85rem;\n}\n\n.profile-meta-list span {\n    display: inline-flex;\n    align-items: center;\n    gap: .45rem;\n    min-height: 32px;\n    padding: .35rem .65rem;\n    border: 1px solid #e1ebe4;\n    border-radius: 999px;\n    background: #fff;\n    color: #344054;\n    font-size: .78rem;\n    font-weight: 700;\n}\n\n.profile-meta-list i {\n    color: #2d9152;\n    font-size: .85rem;\n}\n\n.profile-completion {\n    padding: .8rem;\n    border: 1px solid #e1ebe4;\n    border-radius: 8px;\n    background: #fff;\n}\n\n.profile-completion-label {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: .75rem;\n    margin-bottom: .65rem;\n}\n\n.profile-completion-label span {\n    color: #475467;\n    font-size: .78rem;\n    font-weight: 800;\n}\n\n.profile-completion-label strong {\n    color: #1d660f;\n    font-size: .95rem;\n}\n\n.profile-progress {\n    height: 8px;\n    overflow: hidden;\n    border-radius: 999px;\n    background: #e7efe8;\n}\n\n.profile-progress span {\n    display: block;\n    height: 100%;\n    border-radius: inherit;\n    background: linear-gradient(90deg, #2d9152, #f26522);\n    transition: width .25s ease;\n}\n\n.profile-panel {\n    border-color: #dfe8e1;\n    box-shadow: 0 8px 22px rgba(17, 24, 39, 0.06);\n    transition: box-shadow .2s ease, border-color .2s ease;\n}\n\n.profile-panel:hover {\n    border-color: #cddfd2;\n    box-shadow: 0 12px 28px rgba(17, 24, 39, 0.09);\n}\n\n.profile-panel-title {\n    display: flex;\n    align-items: flex-start;\n    gap: .65rem;\n}\n\n.profile-panel-icon {\n    width: 34px;\n    height: 34px;\n    border-radius: 8px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 auto;\n    background: #edf8ef;\n    color: #2d7f45;\n    border: 1px solid #d7eedb;\n}\n\n.profile-panel-icon i {\n    font-size: 1rem;\n}\n\n.profile-subsection {\n    display: flex;\n    align-items: center;\n    gap: .55rem;\n    margin: .2rem 0 .75rem;\n}\n\n.profile-subsection span {\n    color: #152033;\n    font-size: .78rem;\n    font-weight: 800;\n    text-transform: uppercase;\n}\n\n.profile-subsection::after {\n    content: \"\";\n    height: 1px;\n    flex: 1;\n    background: #edf0ee;\n}\n\n.profile-panel .mb-3 {\n    margin-bottom: .85rem !important;\n}\n\n.profile-panel .form-control,\n.profile-panel .form-select {\n    border-width: 1px;\n    border-radius: 6px;\n    background-color: #fff;\n    transition: border-color .2s ease, box-shadow .2s ease, background-color .2s ease;\n}\n\n.profile-panel .form-control:focus,\n.profile-panel .form-select:focus {\n    border-color: #2d9152;\n    box-shadow: 0 0 0 .18rem rgba(45, 145, 82, 0.14);\n}\n\n.profile-panel .form-control[readonly] {\n    border-style: dashed;\n}\n\n.profile-actions {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: auto;\n    padding-top: .25rem;\n}\n\n.profile-actions .save-btn {\n    min-width: 170px;\n    min-height: 40px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: .5rem;\n    border-radius: 6px;\n}\n\n.profile-actions .save-btn:disabled {\n    background: #d8dee3 !important;\n    color: #667085 !important;\n    box-shadow: none !important;\n    cursor: not-allowed;\n}\n\n.profile-side-panel .profile-actions .save-btn {\n    width: 100%;\n}\n\n.profile-side-panel {\n    min-height: 100%;\n}\n\n.profile-side-panel .profile-panel-title {\n    margin-bottom: .65rem;\n}\n\n.profile-side-panel .mb-3 {\n    margin-bottom: .7rem !important;\n}\n\n.profile-inline-warning {\n    margin: -.25rem 0 .9rem;\n    padding: .6rem .75rem;\n    border: 1px solid #ffd6a8;\n    border-radius: 6px;\n    background: #fff8ef;\n    color: #9a4d10;\n    font-size: .78rem;\n    font-weight: 700;\n}\n\n.password-strength-list {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: .25rem .55rem;\n    margin: -.2rem 0 .7rem;\n    padding: .45rem .55rem;\n    border: 1px solid #e4e9e5;\n    border-radius: 6px;\n    background: #fbfcfb;\n}\n\n.password-strength-list span {\n    display: inline-flex;\n    align-items: center;\n    gap: .35rem;\n    color: #667085;\n    font-size: .7rem;\n    font-weight: 700;\n    line-height: 1.2;\n}\n\n.password-strength-list i {\n    color: #98a2b3;\n    font-size: .78rem;\n}\n\n.password-strength-list span.valid {\n    color: #1d660f;\n}\n\n.password-strength-list span.valid i {\n    color: #2d9152;\n}\n\n/* LMS home refresh */\n.lms-home-page {\n    background: #f8faf7;\n    min-height: calc(100vh - 72px);\n    padding: 1.35rem 1rem 1.5rem;\n    overflow-x: clip;\n}\n\n.lms-home-hero {\n    display: block;\n    max-width: 1720px;\n    margin: 0 auto;\n    padding: 0;\n    position: relative;\n}\n\n.lms-home-hero .slide-show {\n    margin: 0;\n}\n\n.loginCarousel img {\n    width: 100%;\n    height: 170px;\n    object-fit: cover;\n    object-position: center;\n}\n\n.loginCarousel .swiper-button-prev,\n.loginCarousel .swiper-button-next {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 44px;\n    height: 52px;\n    background: #3f8d42;\n    opacity: 1;\n    border-radius: 5px;\n    z-index: 5;\n    color: #fff;\n    padding: 12px;\n    border:none;\n    top: 42%;\n    transform: translateY(-42%);\n    margin-top: 0;\n}\n\n.loginCarousel .swiper-button-prev {\n    left: 2rem;\n}\n\n.loginCarousel .swiper-button-next {\n    right: 2rem;\n}\n\n.loginCarousel .swiper-pagination-bullet {\n    width: 30px;\n    height: 4px;\n    border: 0;\n    border-radius: 99px;\n    background-color: rgba(255, 255, 255, 0.5);\n    opacity: 1;\n}\n\n.loginCarousel .swiper-pagination-bullet-active {\n    background-color: rgba(255, 255, 255, 1);\n}\n\n.lms-role-actions {\n    margin: 0;\n    position: relative;\n}\n\n.lms-role-actions .new-coursebtn {\n    position: static;\n    top: auto;\n    left: auto;\n    transform: none;\n    margin: .85rem 0 0;\n    padding: .9rem 1rem;\n    border: 1px solid #dfeee2;\n    border-radius: 8px;\n    background: #fff;\n    box-shadow: 0 8px 20px rgba(32, 75, 45, 0.08);\n}\n\n.lms-role-actions .new-coursebtn.green-gradient-bg {\n    background-image: url(https://pmfby.amnex.co.in/pmfby/lms/green-gradient-bg.png);\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.lms-home-hero>.lms-role-actions:first-child .new-coursebtn {\n    margin-top: 0;\n}\n\n.lms-role-actions h6 {\n    margin-bottom: .75rem;\n    color: #18351f;\n    font-family: var(--fontOpenSans);\n    font-size: 1.18rem;\n    font-weight: 800;\n    line-height: 1.35;\n    letter-spacing: 0;\n}\n\n.lms-role-actions .small {\n    color: #405c46;\n    font-size: .9rem;\n    font-weight: 600;\n    line-height: 1.45;\n}\n\n.lms-banner-action {\n    min-height: 38px;\n    margin: .25rem .35rem;\n    border-radius: 6px;\n    font-weight: 700;\n}\n\n.lms-home-content {\n    max-width: 1720px;\n    margin: 1.1rem auto 0;\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n}\n\n.lms-home-main,\n.lms-home-side {\n    padding-left: .5rem;\n    padding-right: .5rem;\n}\n\n.lms-home-content>.row,\n.course-toolbar,\n.course-grid {\n    margin-left: 0;\n    margin-right: 0;\n}\n\n.course-toolbar,\n.course-grid {\n    width: 100%;\n}\n\n.learners-tabsinfo {\n    background: #f1f3f1;\n    border: 0;\n    border-radius: 6px;\n    display: flex;\n    gap: 0;\n    justify-content: stretch;\n    min-height: 52px;\n    overflow: hidden;\n}\n\n.learners-tabsinfo .nav-item {\n    flex: 1 1 0;\n}\n\n.learners-tabsinfo .nav-link {\n    width: 100%;\n    height: 52px;\n    color: #172033;\n    border: 0;\n    border-radius: 0;\n    font-weight: 700;\n    padding: .9rem 1rem;\n}\n\n.learners-tabsinfo .nav-link:hover,\n.learners-tabsinfo .nav-link:focus {\n    border: 0;\n    color: #1d5929;\n}\n\n.learners-tabsinfo .nav-link.active {\n    background: #3f7e3f;\n    color: #fff;\n    border: 0;\n    border-radius: 5px;\n}\n\n.course-toolbar {\n    align-items: center;\n    gap: .75rem 0;\n    margin: .95rem 0 0;\n}\n\n.course-toolbar-title h6 {\n    margin: 0;\n    color: #121826;\n    font-size: 1.12rem;\n    font-weight: 800;\n    line-height: 1.3;\n    letter-spacing: 0;\n}\n\n.course-toolbar-title span {\n    display: block;\n    color: #667085;\n    font-size: .82rem;\n    font-weight: 600;\n    line-height: 1.35;\n    margin-top: .15rem;\n}\n\n.course-search .form-control {\n    height: 48px !important;\n    border: 1px solid #dde3df;\n    border-radius: 6px !important;\n    box-shadow: 0 2px 8px rgba(17, 24, 39, 0.04);\n    color: #1f2937;\n    font-size: .9rem;\n    font-weight: 600;\n}\n\n.course-search .form-control::placeholder {\n    color: #8a94a6;\n    font-weight: 500;\n}\n\n.course-search .search-icon2 {\n    right: 12px;\n    top: 0;\n    width: 48px;\n    height: 48px;\n    border-radius: 0 6px 6px 0;\n    background: #3f7e3f;\n}\n\n.course-search .search-icon2::before {\n    color: #fff;\n    left: 16px;\n    top: 12px;\n}\n\n.course-view-switcher {\n    display: inline-flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 0;\n}\n\n.course-view-switcher span {\n    height: 48px;\n    display: inline-flex;\n    align-items: center;\n    padding: 0 .8rem;\n    border: 1px solid #dde3df;\n    border-right: 0;\n    border-radius: 6px 0 0 6px;\n    background: #fff;\n    color: #1f2937;\n    font-size: .86rem;\n    font-weight: 800;\n}\n\n.course-view-switcher .btn {\n    width: 42px;\n    height: 48px;\n    border: 1px solid #dde3df;\n    border-radius: 0;\n    background: #fff;\n    color: #263238;\n    padding: 0;\n}\n\n.course-view-switcher .btn:last-child {\n    border-radius: 0 6px 6px 0;\n}\n\n.course-view-switcher .btn.active,\n.course-view-switcher .btn:hover {\n    background: #3f7e3f;\n    border-color: #3f7e3f;\n    color: #fff;\n}\n\n.course-grid {\n    margin-top: 1.5rem;\n    overflow: visible;\n}\n\n.course-card {\n    margin-bottom: 1.4rem;\n    position: relative;\n    overflow: visible;\n}\n\n.course-card:hover {\n    z-index: 30;\n}\n\n.course-listing,\n.course-listing-learner {\n    min-height: 0;\n    height: 100%;\n    border: 1px solid #dfe6e1;\n    border-radius: 7px;\n    overflow: hidden;\n    box-shadow: 0 4px 14px rgba(17, 24, 39, 0.06);\n    transition: transform .2s ease, box-shadow .2s ease;\n}\n\n.course-grid:not(.course-grid-list) .course-listing:hover,\n.course-grid:not(.course-grid-list) .course-listing-learner:hover {\n    position: relative;\n    width: 100%;\n    transform: scale(1.035);\n    box-shadow: 0 12px 26px rgba(17, 24, 39, 0.13);\n    overflow: visible;\n    z-index: 30;\n}\n\n.course-grid-list .course-listing:hover,\n.course-grid-list .course-listing-learner:hover {\n    position: relative;\n    width: 100%;\n    transform: none;\n    box-shadow: 0 12px 26px rgba(17, 24, 39, 0.13);\n    overflow: visible;\n    z-index: 30;\n}\n\n.course-thumbnail {\n    height: 214px;\n    padding-top: 0;\n    background: #edf2ed;\n    overflow: hidden;\n}\n\n.course-thumbnail img {\n    width: 100%;\n    object-fit: cover;\n}\n\n.course-card-body {\n    padding: .75rem 1rem .85rem;\n    position: relative;\n}\n\n.course-status {\n    display: inline-flex;\n    align-items: center;\n    min-height: 18px;\n    border-radius: 2px;\n    padding: 0 .6rem;\n    margin-bottom: .35rem;\n    background: #5645b8;\n    color: #fff;\n    font-size: .68rem;\n    font-weight: 800;\n    text-transform: capitalize;\n    letter-spacing: .01rem;\n}\n\n.course-status.public,\n.course-status.mandate {\n    background: #5645b8;\n    color: #fff;\n}\n\n.course-status.approve {\n    background: #cafde5;\n    border-color: #b8f3d7;\n    color: #17351f;\n}\n\n.course-listing h6,\n.course-listing-learner h6 {\n    color: #182033;\n    font-family: var(--fontOpenSans);\n    font-size: .98rem;\n    font-weight: 800;\n    line-height: 1.28;\n    letter-spacing: 0;\n    text-transform: none;\n}\n\n.course-listing .card-text,\n.course-listing-learner .card-text {\n    color: #5f6b7a;\n    font-family: var(--fontOpenSans);\n    font-size: .82rem;\n    font-weight: 500;\n    min-height: 20px;\n    line-height: 1.5;\n    letter-spacing: 0;\n    text-transform: none;\n}\n\n.start-info,\n.last-view-info {\n    color: #2f3a4a;\n    font-family: var(--fontOpenSans);\n    font-size: .78rem;\n    font-weight: 600;\n    line-height: 1.55;\n    letter-spacing: 0;\n}\n\n.course-card small {\n    color: #3f4858;\n    font-size: .74rem;\n    font-weight: 500;\n}\n\n.course-hover-details {\n    display: none;\n    position: absolute;\n    left: .75rem;\n    right: .75rem;\n    top: 2.55rem;\n    z-index: 40;\n    max-height: none;\n    overflow: visible;\n    padding: .75rem .85rem;\n    border: 1px solid #dfe6e1;\n    border-radius: 6px;\n    background: #fff;\n    box-shadow: 0 16px 34px rgba(17, 24, 39, 0.18);\n}\n\n.course-hover-details h6 {\n    margin: 0 0 .35rem;\n    color: #111827;\n    font-size: 1rem;\n    font-weight: 800;\n    line-height: 1.3;\n}\n\n.course-hover-details p {\n    margin: 0;\n    color: #566173;\n    font-size: .84rem;\n    font-weight: 500;\n    line-height: 1.5;\n    text-transform: none;\n}\n\n.course-listing:hover .course-hover-details,\n.course-listing-learner:hover .course-hover-details {\n    display: block;\n}\n\n.course-listing-learner:hover h6,\n.course-grid-list .course-listing-learner h6 {\n    font-size: 1rem;\n    line-height: 1.3;\n}\n\n.course-listing-learner:hover .card-text,\n.course-grid-list .course-listing-learner .card-text {\n    color: #566173;\n    font-size: .84rem;\n    font-weight: 500;\n    line-height: 1.48;\n    text-transform: none;\n}\n\n.course-grid-list .course-listing,\n.course-grid-list .course-listing-learner {\n    display: grid;\n    grid-template-columns: 280px minmax(0, 1fr);\n}\n\n.course-grid-list .course-thumbnail {\n    height: 100%;\n    min-height: 190px;\n    background: #f4f7f4;\n}\n\n.course-grid-list .course-thumbnail img {\n    object-fit: contain;\n}\n\n.course-grid-compact .course-thumbnail {\n    height: 170px;\n}\n\n.learner-rightside-widgetbox {\n    min-height: 100%;\n    border: 1px solid #dde6df;\n    border-radius: 8px;\n    background: #fff;\n    padding: 1rem 1rem .25rem;\n    box-shadow: 0 4px 14px rgba(17, 24, 39, 0.05);\n}\n\n.learner-rightside-widgetbox h6 {\n    margin: 0 -1rem .75rem;\n    padding: 0 1rem .8rem;\n    border-bottom: 1px solid #edf0ee;\n    font-size: 1.02rem;\n    font-weight: 800;\n    line-height: 1.35;\n    background: linear-gradient(180deg, #ffb51f, #f46f18);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n.certificate-infobox {\n    margin: 0 -1rem;\n    padding: .75rem 1rem;\n    border-bottom: 1px solid #edf0ee;\n    align-items: center;\n}\n\n.certificate-infobox img {\n    border: 1px solid #f1c94a;\n    border-radius: 2px;\n}\n\n.certificate-infobox h5 {\n    color: #172033;\n    font-size: .84rem;\n    font-weight: 800;\n    line-height: 1.35;\n    margin-bottom: .4rem;\n}\n\n.certificate-infobox span,\n.certificate-empty {\n    color: #5f6b7a;\n    font-size: .76rem;\n    font-weight: 600;\n}\n.togel-password{\n    position: absolute;\n    z-index: 10;\n    right: 0;\n    top: 0;\n    height: 44px;\n    border-radius: 0px 5px 5px 0px;\n    background-color: #ffffff;\n}\n\n/* Training events */\n.training-events-public-wrap {\n    background: #fff;\n    padding: 2rem 0 .75rem;\n}\n\n.lms-home-events {\n    max-width: 1720px;\n    margin: 0 auto 1.1rem;\n}\n\n.training-events-section {\n    width: 100%;\n}\n\n.training-events-compact .training-events-header {\n    margin-bottom: .75rem;\n}\n\n.training-events-compact .training-events-grid {\n    row-gap: 0;\n}\n\n.training-events-compact .training-events-grid > [class*=\"col-\"] {\n    flex: 0 0 100%;\n    max-width: 100%;\n    margin-bottom: 1rem;\n}\n\n.training-events-compact .training-events-grid > [class*=\"col-\"]:last-child {\n    margin-bottom: 0;\n}\n\n.training-events-compact .training-event-card,\n.training-events-compact .training-event-skeleton {\n    min-height: 0;\n    margin-bottom: 0;\n}\n\n.training-events-compact .training-event-thumb {\n    height: 104px;\n}\n\n.training-events-compact .training-event-body {\n    min-height: 142px;\n    padding: .75rem .85rem .85rem;\n}\n\n.training-events-compact .training-event-body h5 {\n    font-size: .92rem;\n}\n\n.training-events-sidebar {\n    margin-bottom: 1rem;\n}\n\n.training-events-sidebar .training-events-grid {\n    row-gap: 1rem;\n}\n\n.training-events-sidebar .training-events-header {\n    margin-bottom: .75rem;\n}\n\n.training-events-sidebar .training-events-header h4 {\n    font-size: 1rem;\n}\n\n.training-events-sidebar .training-events-header p {\n    font-size: .74rem;\n    line-height: 1.35;\n}\n\n.training-events-sidebar .training-events-grid > [class*=\"col-\"] {\n    flex: 0 0 100%;\n    max-width: 100%;\n    margin-bottom: 0;\n}\n\n.training-events-sidebar .training-events-grid > [class*=\"col-\"]:last-child {\n    margin-bottom: 0;\n}\n\n.training-events-sidebar .training-event-card,\n.training-events-sidebar .training-event-skeleton {\n    min-height: 0;\n    margin-bottom: 0;\n}\n\n.training-events-sidebar .training-event-thumb {\n    height: 112px;\n}\n\n.training-events-sidebar .training-event-body {\n    min-height: 144px;\n    padding: .75rem .85rem .85rem;\n}\n\n.training-events-sidebar .training-event-body h5 {\n    font-size: .92rem;\n}\n\n.training-events-header {\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    gap: 1rem;\n    margin-bottom: 1rem;\n}\n\n.training-events-header h4 {\n    color: #172033;\n    font-family: var(--fontOpenSans);\n    font-size: 1.22rem;\n    font-weight: 800;\n    line-height: 1.3;\n    margin: 0;\n    animation: trainingHeadingFlash 1.8s ease-in-out infinite;\n}\n\n@keyframes trainingHeadingFlash {\n    0%,\n    100% {\n        color: #172033;\n        text-shadow: none;\n    }\n    50% {\n        color: #f26522;\n        text-shadow: 0 0 10px rgba(242, 101, 34, 0.28);\n    }\n}\n\n.training-events-header p {\n    color: #667085;\n    font-size: .86rem;\n    font-weight: 600;\n    line-height: 1.45;\n    margin: .2rem 0 0;\n}\n\n.training-events-grid {\n    gap: 0;\n}\n\n.training-event-card {\n    height: 100%;\n    min-height: 316px;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    margin-bottom: 1rem;\n    border: 1px solid #dfe6e1;\n    border-radius: 7px;\n    background: #fff;\n    box-shadow: 0 4px 14px rgba(17, 24, 39, 0.06);\n}\n\n.training-event-thumb {\n    height: 142px;\n    background: #edf2ed;\n    overflow: hidden;\n}\n\n.training-event-thumb img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.training-event-body {\n    min-height: 174px;\n    display: flex;\n    flex-direction: column;\n    padding: .85rem .95rem .95rem;\n}\n\n.training-event-meta {\n    display: flex;\n    flex-wrap: wrap;\n    gap: .45rem .8rem;\n    min-height: 22px;\n    color: #526071;\n    font-size: .74rem;\n    font-weight: 700;\n    line-height: 1.35;\n    text-transform: capitalize;\n}\n\n.training-event-meta i {\n    color: #3f7e3f;\n    margin-right: .25rem;\n}\n\n.training-event-body h5 {\n    color: #172033;\n    font-family: var(--fontOpenSans);\n    font-size: 1rem;\n    font-weight: 800;\n    line-height: 1.3;\n    margin: .55rem 0 .35rem;\n}\n\n.training-event-body p {\n    color: #5f6b7a;\n    font-size: .82rem;\n    font-weight: 500;\n    line-height: 1.48;\n    margin: 0;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.training-event-footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: .75rem;\n    margin-top: auto;\n    padding-top: .9rem;\n}\n\n.training-event-type {\n    min-height: 24px;\n    display: inline-flex;\n    align-items: center;\n    padding: 0 .65rem;\n    border: 1px solid #d7eedb;\n    border-radius: 4px;\n    background: #edf8ef;\n    color: #225b2d;\n    font-size: .72rem;\n    font-weight: 800;\n    text-transform: capitalize;\n}\n\n.training-event-action {\n    min-height: 34px;\n    border: 0 !important;\n    border-radius: 5px;\n    background: #f26522 !important;\n    color: #fff !important;\n    font-size: .78rem;\n    font-weight: 800;\n    padding: .35rem .8rem;\n    white-space: nowrap;\n}\n\n.training-event-action:hover,\n.training-event-action:focus {\n    background: #d35400 !important;\n    color: #fff !important;\n}\n\n.training-event-skeleton {\n    position: relative;\n    min-height: 316px;\n    background: linear-gradient(90deg, #eef3ef 25%, #f7faf8 37%, #eef3ef 63%);\n    background-size: 400% 100%;\n    animation: trainingEventSkeleton 1.3s ease infinite;\n}\n\n@keyframes trainingEventSkeleton {\n    0% {\n        background-position: 100% 0;\n    }\n    100% {\n        background-position: 0 0;\n    }\n}\n\n@media (max-width: 767px) {\n    .about-lms-main {\n        padding-right: 0;\n    }\n\n    .about-events-panel {\n        padding-left: 0;\n        border-left: 0;\n        margin-top: 1rem;\n    }\n\n    .training-events-public-wrap {\n        padding: 1.25rem .75rem .25rem;\n    }\n\n    .lms-home-events {\n        margin-bottom: .75rem;\n    }\n\n    .training-events-header {\n        align-items: flex-start;\n        flex-direction: column;\n    }\n\n    .training-event-card,\n    .training-event-skeleton {\n        min-height: 300px;\n    }\n\n    .training-event-thumb {\n        height: 132px;\n    }\n\n    .training-event-footer {\n        align-items: flex-start;\n        flex-direction: column;\n    }\n}\n\n/* Training event admin */\n.training-admin-page {\n    padding: 1rem;\n}\n\n.training-admin-form,\n.training-admin-list {\n    border: 1px solid #dfe6e1;\n    border-radius: 8px;\n    background: #fff;\n    box-shadow: 0 4px 14px rgba(17, 24, 39, 0.06);\n    margin-bottom: 1rem;\n    padding: 1rem;\n}\n\n.training-admin-form h4 {\n    color: #172033;\n    font-family: var(--fontOpenSans);\n    font-size: 1.18rem;\n    font-weight: 800;\n    line-height: 1.3;\n    margin: 0;\n}\n\n.training-admin-form h4 + span,\n.training-admin-list h6 + span {\n    color: #667085;\n    display: block;\n    font-size: .82rem;\n    font-weight: 600;\n    margin-top: .15rem;\n}\n\n.training-admin-flags {\n    display: flex;\n    flex-direction: column;\n    gap: .55rem;\n    justify-content: center;\n}\n\n.training-admin-flags .form-check-label {\n    color: #172033;\n    font-size: .84rem;\n    font-weight: 700;\n}\n\n.training-admin-flags small {\n    color: #667085;\n    display: block;\n    font-size: .72rem;\n    font-weight: 600;\n    overflow-wrap: anywhere;\n}\n\n.training-admin-list h6 {\n    color: #172033;\n    font-family: var(--fontOpenSans);\n    font-size: 1rem;\n    font-weight: 800;\n    margin: 0;\n}\n\n.training-admin-event-cell {\n    display: grid;\n    grid-template-columns: 82px minmax(0, 1fr);\n    gap: .75rem;\n    align-items: center;\n    min-width: 320px;\n}\n\n.training-admin-thumb {\n    width: 82px;\n    height: 52px;\n    object-fit: cover;\n    border: 1px solid #dde6df;\n    border-radius: 5px;\n    background: #edf2ed;\n}\n\n.training-admin-event-cell strong {\n    color: #172033;\n    display: block;\n    font-size: .82rem;\n    font-weight: 800;\n    line-height: 1.3;\n}\n\n.training-admin-event-cell span {\n    color: #667085;\n    display: block;\n    font-size: .72rem;\n    font-weight: 700;\n    line-height: 1.4;\n    text-transform: capitalize;\n}\n\n.training-admin-status {\n    min-width: 76px;\n    min-height: 24px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n    font-size: .72rem;\n    font-weight: 800;\n    text-transform: capitalize;\n}\n\n.training-admin-status.draft {\n    background: #fdf2ca;\n    color: #7a4d00;\n}\n\n.training-admin-status.published {\n    background: #cafde5;\n    color: #17351f;\n}\n\n.training-admin-status.cancelled {\n    background: #fdcaca;\n    color: #7a1f1f;\n}\n\n.training-admin-status.completed {\n    background: #e7ebf0;\n    color: #344054;\n}\n\n.training-admin-actions {\n    display: inline-flex;\n    gap: .35rem;\n    align-items: center;\n}\n\n.training-admin-actions .btn {\n    width: 32px;\n    height: 32px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    border: 1px solid #dde6df;\n    border-radius: 5px;\n    background: #fff;\n    color: #263238;\n}\n\n.training-admin-actions .btn:hover:not(:disabled),\n.training-admin-actions .btn:focus:not(:disabled) {\n    background: #3f7e3f;\n    border-color: #3f7e3f;\n    color: #fff;\n}\n\n.training-admin-actions .btn:disabled {\n    background: #f2f4f3;\n    color: #98a2b3;\n    cursor: not-allowed;\n}\n\n@media (max-width: 767px) {\n    .training-admin-page {\n        padding: .75rem;\n    }\n\n    .training-admin-event-cell {\n        min-width: 280px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
